import { getEnvironment } from '../utils/utility';

export const ENVIRONMENT = {
    DEV: 'DEV',
    QA: 'QA',
    LOCAL: 'LOCAL',
    PROD: 'PROD',
}

export const LOGOUT_REDIRECT_URI = () => {
    const ENV = getEnvironment();
    let url = '';
    if (ENV === ENVIRONMENT.PROD) {
        url = 'https://addieinsights.com';
    } else if (ENV === ENVIRONMENT.QA) {
        url = 'https://dairystage.addieinsights.com';
    } else if (ENV === ENVIRONMENT.DEV) {
        url = 'https://dairydev.addieinsights.com';
    } else {
        url = 'http://localhost:3001';
    }
    return url;
}

export const SSO_BASE_PATH = () => {
    const ENV = getEnvironment();
    let url = '';
    if (ENV === ENVIRONMENT.PROD) {
        url = 'https://sso.landolakesinc.com';
    } else if (ENV === ENVIRONMENT.QA) {
        url = 'https://ssoqa.landolakesinc.com';
    } else if (ENV === ENVIRONMENT.DEV) {
        url = 'https://ssoqa.landolakesinc.com';
    } else {
        url = 'https://ssoqa.landolakesinc.com';
    }
    return url;
}

export const SNACKBAR_TYPE = {
    'ERROR': 'error',
    'WARNING': 'warning',
    'DEFAULT': 'default',
    'SUCCESS': 'success'
}

export const REPORT_TYPE = {
    'BENCHMARK_SNAPSHOT': 'benchmark-report',
    'SNAPSHOT_REPORT': 'snapshot-report',
    'SNAPSIX_REPORT': 'snapsix-report',
    'PERIODCOMPARISON_REPORT': 'periodcomparison-report',
    "CULLINGHISTORY_REPORT": 'culling-report',
    "SNAPSHOTGOAL_REPORT": 'snapshotgoal-report',
    "SUBHERDCOMPARISON_REPORT": 'subherdcomparison-report',
    "HEIFER_REPORT": 'heifer-report'
}

export const primaryfeeddeliverysystemoption = [
    {
        name: "TMR",
        value: "tmr"
    }, {
        name: "PMR",
        value: "pmr"
    }, {
        name: "Top Dress",
        value: "top_dress"
    }, {
        name: "Robots",
        value: "robots"
    }, {
        name: "Grazing",
        value: "grazing"
    }, {
        name: "Parlor Grain",
        value: "parlor_grain"
    }, {
        name: "Other",
        value: "other"
    }
]

export const housingoption = [{
    name: "Free Stalls",
    value: "free_stalls"
}, {
    name: "Dry Lot",
    value: "dry_lot"
}, {
    name: "Pasture",
    value: "pasture"
}, {
    name: "Seasonal Pasture",
    value: "seasonal_pasture"
}, {
    name: "Bedded Pack",
    value: "bedded_pack"
}, {
    name: "Tie Stall",
    value: "tie_stall"
}, {
    name: "Other",
    value: "other"
}]

export const beddingoption = [{
    name: "Sand",
    value: "sand"
}, {
    name: "Mattress",
    value: "mattress"
}, {
    name: "Cow Mats",
    value: "cow_mats"
}, {
    name: "Shavings/Sawdust",
    value: "shaving_sawdust"
}, {
    name: "Straw",
    value: "straw"
}, {
    name: "Paper",
    value: "paper"
}, {
    name: "Composted Manure Solids",
    value: "composted_manure_solids"
}, {
    name: "Pasture",
    value: "pasture"
}, {
    name: "Seasonal Pasture",
    value: "seasonal_pasture"
}, {
    name: "None",
    value: "none"
}, {
    name: "Other",
    value: "other"
}]

export const heatabatementoption = [{
    name: "Fans",
    value: "fans"
}, {
    name: "Sprinklers",
    value: "sprinklers"
}, {
    name: "Shades",
    value: "shades"
}, {
    name: "Ponds",
    value: "ponds"
}, {
    name: "Other",
    value: "other"
}]

export let manuredisposaloptions = [{
    name: "Automatic Scrape",
    value: "automatic_scrape"
}, {
    name: "Tractor Scrape",
    value: "tractor_scrape"
}, {
    name: "Flush System",
    value: "flush_system"
}, {
    name: "Robot",
    value: "robot"
}, {
    name: "Slatted Floor",
    value: "slatted_floor"
}, {
    name: "Other",
    value: "other"
}]

export const breeds = [{
    name: "Crossbred"
}, {
    name: "Holstein"
}, {
    name: "Jersey"
}
    , {
    name: "Other"
}];

export const peergroupbreedsoptions = [{
    name: "Holstein",
    value: "holstein"
}, {
    name: "Jersey",
    value: "jersey"
}, {
    name: "Mixed",
    value: "mixed"
}, {
    name: "Other",
    value: "other"
}]

export const standard_mapping = [{
    name: "S/Standard",
    value: "s_standard"
}, {
    name: "M/Mounting",
    value: "m_mounting"
}, {
    name: "X/Mucus",
    value: "x_mucus"
}, {
    name: "F|Full Kmar",
    value: "f_full_kmar",
}, {
    name: "R|Part Kmar",
    value: "r_part_kmar"
}, {
    name: "O|Ovarian Palpation",
    value: "o_ovarian_palpation"
}, {
    name: "C|Chalk/Paint",
    value: "c_chalk_paint"
}, {
    name: "P|Pedometer",
    value: "p_pedometer"
}, {
    name: "T|Timed AI",
    value: "t_timed_ai"
}, {
    name: "N|Nervousness",
    value: "n_nervousness"
}, {
    name: "E|Edema",
    value: "e_edema"
}, {
    name: "U|Ultrasound",
    value: "u_ultrasound"
}, {
    name: "Y|User def1",
    value: "y_user_def_1"
}, {
    name: "Z|User def 2",
    value: "z_user_def_2"
}, {
    name: "1|Less than 2hr (at Observation)",
    value: "1_less_than_2hr_observation"
}, {
    name: "2|From 2 to 12hrs after Observation",
    value: "2_from_2_to_12_after_observation"
}, {
    name: "3|More than 12 hrs after Observation",
    value: "3_more_than_12_hrs_after_observation"
}]

export let stateoptions = [
    { name: 'AK', value: 'AK' },
    { name: 'AL', value: 'AL' },
    { name: 'AR', value: 'AR' },
    { name: 'AZ', value: 'AZ' },
    { name: 'CA', value: 'CA' },
    { name: 'CO', value: 'CO' },
    { name: 'CT', value: 'CT' },
    { name: 'DC', value: 'DC' },
    { name: 'DE', value: 'DE' },
    { name: 'FL', value: 'FL' },
    { name: 'GA', value: 'GA' },
    { name: 'HI', value: 'HI' },
    { name: 'IA', value: 'IA' },
    { name: 'ID', value: 'ID' },
    { name: 'IL', value: 'IL' },
    { name: 'IN', value: 'IN' },
    { name: 'KS', value: 'KS' },
    { name: 'KY', value: 'KY' },
    { name: 'LA', value: 'LA' },
    { name: 'MA', value: 'MA' },
    { name: 'MD', value: 'MD' },
    { name: 'ME', value: 'ME' },
    { name: 'MI', value: 'MI' },
    { name: 'MN', value: 'MN' },
    { name: 'MO', value: 'MO' },
    { name: 'MS', value: 'MS' },
    { name: 'MT', value: 'MT' },
    { name: 'NC', value: 'NC' },
    { name: 'ND', value: 'ND' },
    { name: 'NE', value: 'NE' },
    { name: 'NH', value: 'NH' },
    { name: 'NJ', value: 'NJ' },
    { name: 'NM', value: 'NM' },
    { name: 'NV', value: 'NV' },
    { name: 'NY', value: 'NY' },
    { name: 'OH', value: 'OH' },
    { name: 'OK', value: 'OK' },
    { name: 'OR', value: 'OR' },
    { name: 'PA', value: 'PA' },
    { name: 'PR', value: 'PR' },
    { name: 'RI', value: 'RI' },
    { name: 'SC', value: 'SC' },
    { name: 'SD', value: 'SD' },
    { name: 'TN', value: 'TN' },
    { name: 'TX', value: 'TX' },
    { name: 'UT', value: 'UT' },
    { name: 'VA', value: 'VA' },
    { name: 'VT', value: 'VT' },
    { name: 'WA', value: 'WA' },
    { name: 'WI', value: 'WI' },
    { name: 'WV', value: 'WV' },
    { name: 'WY', value: 'WY' }
]

export const standard_cull_mapping = [{
    name: "Sold Foot/Leg",
    value: "sold_foot_leg"
}, {
    name: "Sold Dairy",
    value: "sold_dairy"
}, {
    name: "Sold Low Production",
    value: "sold_low_production"
}, {
    name: "Sold Reproductive",
    value: "sold_reproductive"
}, {
    name: "Sold Injury/Other",
    value: "sold_injury_other"
}, {
    name: "Died",
    value: "died"
}, {
    name: "Sold Mastitis",
    value: "sold_mastitis"
}, {
    name: "Sold Disease",
    value: "sold_disease"
}, {
    name: "Sold Udder",
    value: "sold_udder"
}, {
    name: "Not Reported",
    value: "not_reported"
}]

export const healthcodemapping = [{
    label: "Retained Placenta",
    healthcode: "retained_placenta_code",
    name: "Retained_Placenta"
}, {
    label: "Metritis",
    healthcode: "metritis_code",
    name: "Metritis"
}, {
    label: "Ketosis",
    healthcode: "ketosis_code",
    name: "Ketosis"
}, {
    label: "Displaced Abomasum",
    healthcode: "displaced_abomasum_code",
    name: "Displaced_Abomasum"
}, {
    label: "Milk Fever",
    healthcode: "milk_fever_code",
    name: "Milk_Fever"
}, {
    label: "Mastitis",
    healthcode: "mastitis_code",
    name: "Mastitis"
}, {
    label: "Abortions",
    healthcode: "abortions_code",
    name: "Abortions"
}, {
    label: "Lameness",
    healthcode: "lameness_code",
    name: "Lameness"
}, {
    label: "Hoof Trimming",
    healthcode: "hoof_training_code",
    name: "Hoof_Trimming"
}]

export const facility = [
    {
        name: "Rotary",
        value: "rotary"
    }, {
        name: "Robot",
        value: "robot"
    }, {
        name: "Parallel",
        value: "parallel"
    }, {
        name: "Herringbone",
        value: "herring_bone"
    }, {
        name: "Parabone",
        value: "parabone"
    }, {
        name: "Polygon",
        value: "polygon"
    }, {
        name: "Side Open",
        value: "side_open"
    }, {
        name: "Flat Barn",
        value: "flat_barn"
    }, {
        name: "Tie Stall",
        value: "tie_stall"
    }, {
        name: "Other",
        value: "other"
    }]

export const milking_frequency_options = [{
    name: "2x",
    value: "2x"
}, {
    name: "3x",
    value: "3x"
}, {
    name: "4x",
    value: "4x"
}, {
    name: "Robot",
    value: "robot"
}, {
    name: "Mixed",
    value: "mixed"
}, {
    name: "Other",
    value: "other"
}]

export const breeding_tool = [{
    name: "Timed AI",
    value: "timed_ai"
}, {
    name: "Activity",
    value: "activity"
}, {
    name: "Chalk/Paint",
    value: "chalk_paint"
}, {
    name: "Heat Observation",
    value: "heat_observation"
}, {
    name: "Ovarian Palpation",
    value: "ovarian_palpation"
}, {
    name: "Ultrasound",
    value: "ultrasound"
}, {
    name: "Exposure to Bull",
    value: "exposure_to_bull"
}, {
    name: "CIDR",
    value: "cidr"
}, {
    name: "Other",
    value: "other"
}]

export const breedingprogram = [{
    name: "none",
    value: "none"
}, {
    name: "OvSync",
    value: "ovsync"
}, {
    name: "PreSync",
    value: "presync"
}, {
    name: "Ovs+Pre",
    value: "ovspre"
}, {
    name: "Modified",
    value: "modified"
}, {
    name: "Other",
    value: "other"
}]

export const pregnancydetection = [{
    name: "Palpation",
    value: "palpation"
}, {
    name: "Ultrasound",
    value: "ultrasound"
}, {
    name: "Milk Test",
    value: "milk_test"
}, {
    name: "Blood Test",
    value: "blood_test"
}]

export const herdreplacement = [{
    name: "Raised",
    value: "raised"
}, {
    name: "Purchased",
    value: "purchased"
}, {
    name: "Both",
    value: "both"
}]

export const milkcooperativeoptions = [
    {
        name: 'Addison Cooperative Milk Producers Association, Inc',
        value: 'Addison Cooperative Milk Producers Association, Inc'
    },
    { name: 'Agri-Mark, Inc.', value: 'Agri-Mark, Inc.' },
    {
        name: 'Appalachian Dairy Farmers Cooperative',
        value: 'Appalachian Dairy Farmers Cooperative'
    },
    {
        name: 'Associated Milk Producers Inc.',
        value: 'Associated Milk Producers Inc.'
    },
    { name: 'Bongards Creameries', value: 'Bongards Creameries' },
    {
        name: 'Boonville Farms Cooperative, Inc',
        value: 'Boonville Farms Cooperative, Inc'
    },
    {
        name: 'Burnett Dairy Cooperative',
        value: 'Burnett Dairy Cooperative'
    },
    {
        name: 'California Dairies, Inc.',
        value: 'California Dairies, Inc.'
    },
    { name: 'Cayuga Marketing LLC.', value: 'Cayuga Marketing LLC.' },
    {
        name: 'Central Equity Milk Cooperative, Inc',
        value: 'Central Equity Milk Cooperative, Inc'
    },
    {
        name: 'Clarco Farmers Cooperative',
        value: 'Clarco Farmers Cooperative'
    },
    {
        name: 'Cobblestone Milk Cooperative, Inc.',
        value: 'Cobblestone Milk Cooperative, Inc.'
    },
    {
        name: 'Cooperative Milk Producers Association ',
        value: 'Cooperative Milk Producers Association '
    },
    {
        name: 'Cooperative Regions of Organic Producer Pools',
        value: 'Cooperative Regions of Organic Producer Pools'
    },
    {
        name: 'Cumberland Valley Milk Producers',
        value: 'Cumberland Valley Milk Producers'
    },
    {
        name: 'Dairy Farmers of America, Inc.',
        value: 'Dairy Farmers of America, Inc.'
    },
    {
        name: 'Dairystream Cooperative, Inc.',
        value: 'Dairystream Cooperative, Inc.'
    },
    {
        name: 'Down State Milk Producers Cooperative, Inc.',
        value: 'Down State Milk Producers Cooperative, Inc.'
    },
    {
        name: 'Edge Dairy Farmer Cooperative',
        value: 'Edge Dairy Farmer Cooperative'
    },
    {
        name: 'Elba Co-operative Creamery Association',
        value: 'Elba Co-operative Creamery Association'
    },
    {
        name: 'Ellsworth Cooperative Creamery',
        value: 'Ellsworth Cooperative Creamery'
    },
    {
        name: 'Elm Dale Creamery Association',
        value: 'Elm Dale Creamery Association'
    },
    {
        name: 'Erie Cooperative Association, Inc.',
        value: 'Erie Cooperative Association, Inc.'
    },
    {
        name: 'Farmers Co-operative Creamery Company',
        value: 'Farmers Co-operative Creamery Company'
    },
    {
        name: 'Farmers Union Milk Producers Association',
        value: 'Farmers Union Milk Producers Association'
    },
    {
        name: 'FarmFirst Dairy Cooperative',
        value: 'FarmFirst Dairy Cooperative'
    },
    {
        name: 'Fingerlakes Milk Cooperative Inc.',
        value: 'Fingerlakes Milk Cooperative Inc.'
    },
    {
        name: 'Foremost Farms USA, Cooperative',
        value: 'Foremost Farms USA, Cooperative'
    },
    {
        name: 'Gilman Cooperative Creamery',
        value: 'Gilman Cooperative Creamery'
    },
    {
        name: 'Great Lakes Milk Producers',
        value: 'Great Lakes Milk Producers'
    },
    {
        name: 'Great Plains Dairymen’s Association',
        value: 'Great Plains Dairymen’s Association'
    },
    { name: 'High Desert Milk, Inc', value: 'High Desert Milk, Inc' },
    {
        name: 'Hilmar Cheese Company, Inc.',
        value: 'Hilmar Cheese Company, Inc.'
    },
    {
        name: 'H.P. Farmers Cooperative, Inc.',
        value: 'H.P. Farmers Cooperative, Inc.'
    },
    {
        name: 'Independent Dairy Producers, Inc.',
        value: 'Independent Dairy Producers, Inc.'
    },
    {
        name: 'Jefferson Bulk Milk Co-op Inc',
        value: 'Jefferson Bulk Milk Co-op Inc'
    },
    { name: 'Lakes Area Cooperative', value: 'Lakes Area Cooperative' },
    {
        name: 'Lancaster Organic Farmers Co-op',
        value: 'Lancaster Organic Farmers Co-op'
    },
    { name: 'Lanco Dairy Farms Co-op', value: 'Lanco Dairy Farms Co-op' },
    { name: 'Land O’Lakes, Inc.', value: 'Land O’Lakes, Inc.' },
    {
        name: 'Legacy Milk Cooperative, Inc.',
        value: 'Legacy Milk Cooperative, Inc.'
    },
    {
        name: 'Liberty Milk Producers Cooperative, Inc',
        value: 'Liberty Milk Producers Cooperative, Inc'
    },
    {
        name: 'Lone Star Milk Producers, L.C',
        value: 'Lone Star Milk Producers, L.C'
    },
    {
        name: 'Lowville Producers Dairy Cooperative, Inc.',
        value: 'Lowville Producers Dairy Cooperative, Inc.'
    },
    {
        name: 'Magic Valley Quality Milk Producers Inc.',
        value: 'Magic Valley Quality Milk Producers Inc.'
    },
    {
        name: 'Maryland and Virginia Milk Producers Cooperative Association, Inc',
        value: 'Maryland and Virginia Milk Producers Cooperative Association, Inc'
    },
    {
        name: 'Michigan Milk Producers Association',
        value: 'Michigan Milk Producers Association'
    },
    {
        name: 'Middlebury Cooperative Milk Producers Association, Inc.',
        value: 'Middlebury Cooperative Milk Producers Association, Inc.'
    },
    {
        name: 'Mid-West Dairymen’s Company',
        value: 'Mid-West Dairymen’s Company'
    },
    {
        name: 'Mohawk Valley Cooperative, Inc.',
        value: 'Mohawk Valley Cooperative, Inc.'
    },
    {
        name: 'Mount Joy Farmers Co-operative Association',
        value: 'Mount Joy Farmers Co-operative Association'
    },
    {
        name: 'National Farmers Organization, Inc.',
        value: 'National Farmers Organization, Inc.'
    },
    {
        name: 'Nelson Creamery Association',
        value: 'Nelson Creamery Association'
    },
    {
        name: 'Northeast Nebraska Milk Producers Nonstock Cooperative',
        value: 'Northeast Nebraska Milk Producers Nonstock Cooperative'
    },
    {
        name: 'Northwest Dairy Association',
        value: 'Northwest Dairy Association'
    },
    {
        name: 'Oak Park Cooperative Creamery Association',
        value: 'Oak Park Cooperative Creamery Association'
    },
    {
        name: 'Oneida-Lewis Milk Producers Cooperative, Inc.',
        value: 'Oneida-Lewis Milk Producers Cooperative, Inc.'
    },
    {
        name: 'Oneida-Madison Milk Producers Co-operative ',
        value: 'Oneida-Madison Milk Producers Co-operative '
    },
    {
        name: 'Organic Dairy Farmers Cooperative',
        value: 'Organic Dairy Farmers Cooperative'
    },
    {
        name: 'Organic Family Farms Cooperative',
        value: 'Organic Family Farms Cooperative'
    },
    {
        name: 'Osakis Creamery Association',
        value: 'Osakis Creamery Association'
    },
    {
        name: 'Pacific Gold Milk Producers, Inc.',
        value: 'Pacific Gold Milk Producers, Inc.'
    },
    {
        name: 'Pioneer Milk Producers Cooperative, Inc.',
        value: 'Pioneer Milk Producers Cooperative, Inc.'
    },
    {
        name: 'Plainview Milk Products Cooperative',
        value: 'Plainview Milk Products Cooperative'
    },
    {
        name: 'Prairie Farms Dairy, Inc',
        value: 'Prairie Farms Dairy, Inc'
    },
    {
        name: 'Preble Milk Cooperative Association, Inc',
        value: 'Preble Milk Cooperative Association, Inc'
    },
    {
        name: 'Premier Milk, Incorporated',
        value: 'Premier Milk, Incorporated'
    },
    {
        name: 'Pro-Ag Farmers Cooperative',
        value: 'Pro-Ag Farmers Cooperative'
    },
    {
        name: 'Producers Co-operative, Inc.',
        value: 'Producers Co-operative, Inc.'
    },
    {
        name: 'Progressive Dairymen’s Cooperative, Inc.',
        value: 'Progressive Dairymen’s Cooperative, Inc.'
    },
    {
        name: 'Rock Dell Cooperative Creamery Company',
        value: 'Rock Dell Cooperative Creamery Company'
    },
    {
        name: 'Rolling Hills Dairy Producers Cooperative',
        value: 'Rolling Hills Dairy Producers Cooperative'
    },
    {
        name: 'Scenic Central Milk Producers Cooperative Association',
        value: 'Scenic Central Milk Producers Cooperative Association'
    },
    {
        name: 'Scenic Mountain Milk Producers Cooperative, Inc',
        value: 'Scenic Mountain Milk Producers Cooperative, Inc'
    },
    {
        name: 'Scioto County Cooperative Milk Producers’ Association',
        value: 'Scioto County Cooperative Milk Producers’ Association'
    },
    {
        name: 'Select Milk Producers, Inc.',
        value: 'Select Milk Producers, Inc.'
    },
    { name: 'Southeast Milk, Inc', value: 'Southeast Milk, Inc' },
    {
        name: 'Springfield Cooperative Creamery Association',
        value: 'Springfield Cooperative Creamery Association'
    },
    {
        name: 'Steamburg Milk Producers Cooperative, Inc.',
        value: 'Steamburg Milk Producers Cooperative, Inc.'
    },
    { name: 'Sunrise Ag Cooperative', value: 'Sunrise Ag Cooperative' },
    {
        name: 'Swanville Cooperative Creamery Association',
        value: 'Swanville Cooperative Creamery Association'
    },
    { name: 'The Dairy Group, Inc. ', value: 'The Dairy Group, Inc. ' },
    {
        name: 'The First District Association',
        value: 'The First District Association'
    },
    {
        name: 'Tillamook County Creamery Association',
        value: 'Tillamook County Creamery Association'
    },
    {
        name: 'Tri-County Producers’ Cooperative',
        value: 'Tri-County Producers’ Cooperative'
    },
    {
        name: 'United Dairymen of Arizona',
        value: 'United Dairymen of Arizona'
    },
    {
        name: 'Upstate Niagara Cooperative, Inc.',
        value: 'Upstate Niagara Cooperative, Inc.'
    },
    {
        name: 'Venture Dairy Cooperative',
        value: 'Venture Dairy Cooperative'
    },
    {
        name: 'Westby Cooperative Creamery ',
        value: 'Westby Cooperative Creamery '
    },
    {
        name: 'Westco Milk Producers Cooperative',
        value: 'Westco Milk Producers Cooperative'
    },
    {
        name: 'Western Milk Producers Association',
        value: 'Western Milk Producers Association'
    },
    {
        name: 'Western Organic Family Farms Cooperative',
        value: 'Western Organic Family Farms Cooperative'
    },
    {
        name: 'White Eagle Cooperative Association',
        value: 'White Eagle Cooperative Association'
    },
    {
        name: 'Woodstock Progressive Milk Producers’ Association',
        value: 'Woodstock Progressive Milk Producers’ Association'
    }
]

export const supplemental_programsoptions = [{
    name: " American Humane Certified",
    value: " American Humane Certified"
}, {
    name: "Animal Welfare Approved",
    value: "Animal Welfare Approved"
}, {
    name: "Certified Grassfed",
    value: "Certified Grassfed"
}, {
    name: "Certified Humane Certification Program",
    value: "Certified Humane Certification Program"
}, {
    name: "FoodAlliance.org",
    value: "FoodAlliance.org"
}, {
    name: "Global Animal Partnership's 5-Step Program",
    value: "Global Animal Partnership's 5-Step Program"
}, {
    name: "National Dairy FARM Program",
    value: "National Dairy FARM Program"
}, {
    name: "NYSCHAP Cattle Welfare Certification Program",
    value: "NYSCHAP Cattle Welfare Certification Program"
}, {
    name: "USDA Organic",
    value: "USDA Organic"
}, {
    name: "Other",
    value: "Other"
}]

export const accessoptions = [{
    name: "Read Only",
    value: "readonly"
}, {
    name: "Contributor",
    value: "contributor"
}, {
    name: "Owner",
    value: "owner"
}, {
    name: "Remove Access",
    value: "Remove Access"
}]

export const graphidnamemap = {
    "ecmchart": "Energy Corrected Milk",
    "testdaymilkchart": "Test Day Milk",
    "weeklymilkchart": "Weekly Milk",
    "lactation1chart": "1st Lactation",
    "lactation2chart": "2nd Lactation",
    "lactation3chart": "3rd+ Lactation",
    "herddatachart": "Percent Pregnant in Herd",
    "calfheiferchart": "1st Calf Heifer Profiles",
    "daysopenchart": "Days Open",
    "percentfatchart": "Percent Fat",
    "somaticcellchart": "Somatic Cell",
    "percentproteinchart": "Percent Protein",
    "totallbschart": "Total lbs fat+protein",
    "avgdimchart": "Average DIM",
    "calvingintervalchart": "Calving Intervals",
    "annualcullchart": "Annual Cull",
    "lactationcurvechart": "Lactation Curve",
}

export const redcoloredsectionsnamearray = [
    "Herd Inventory",
    "Heifer Enterprise",
    "Reproduction",
    "Culling",
    "Component Analysis",
    "Milk Quality",
    "Calves",
    "Health",
]

export const reporterrorarray = [
    "Please select another name, Report Layout with this name already exists.",
    "Report Layout name should be of at least 3 characters and should be alphanumeric and should not contain any special character other than space.",
    "Name already exists in your Custom Report Layouts. If you continue, you will overwrite your existing custom report layout."
]

export let bargraph = ["test_day_milk_data",
    "percent_pregnant_in_herd_data",
    "first_calf_heifer_profiles_data",
    "days_open_data",
    "percent_fat_data",
    "somatic_cell_count",
    "percent_protein",
    "lbs_fat_protein_data",
    "average_dim",
    "calving_interval",
    "annual_cull_and_death_rates",
    "weekly_milk_data",
    "ecm_data"]

export let formdata = {
    benchmark_report: false,
    // Contact and information
    dairy_name: "",
    dairy_owner_name: "",
    dairy_manager_name: "",
    dairy_street_address: "",
    dairy_street_address_2: "",
    dairy_city: "",
    dairy_state: "",
    dairy_zip_code: "",
    dairy_phone_number: "",
    dairy_mobile_number: "",
    dairy_fax_number: "",
    dairy_email: "",

    // Management Software
    software_herd_software: "PCDART",
    software_herd_code: "",
    software_remote_access_code: "",
    software_breeds: [],
    software_split_report: "No",
    sub_herds: [],

    Retained_Placenta: false,
    retained_placenta_code: "",

    Metritis: false,
    metritis_code: "",

    Ketosis: false,
    ketosis_code: "",

    Displaced_Abomasum: false,
    displaced_abomasum_code: "",

    Milk_Fever: false,
    milk_fever_code: "",

    Mastitis: false,
    mastitis_code: "",

    Abortions: false,
    abortions_code: "",

    Lameness: false,
    lameness_code: "",

    Hoof_Trimming: false,
    hoof_training_code: "",

    software_Breeding_Codes: [],
    // software_culling_codes:[],


    // DHIA
    dhia_daily_milk_weights_recorded: "Yes",
    dhia_dhi_or_other_service_used: "Yes",
    dhia_enrollment_tests_per_year: "",
    dhia_fat: false,
    dhia_protein: false,
    dhia_scc: false,
    dhia_mun: false,
    parlor_daily_milk_weights: false,



    // Milking Facility
    milking_facility_type: [],
    milking_facility_type_other: "",
    milking_stalls_in_parlor: "",
    milking_cows_fed_in_parlor: "No",
    milking_parlor_holding_pen_capacity: "",
    milking_milking_frequency_per_day: "",
    milking_milking_frequency_per_day_mixed_other: "",
    milking_milking_frequency_per_day_robot: "",
    milking_facility_active_hours_per_day: "",


    // Reproductive Management
    reproductive_primary_breeding_method: "AI",
    reproductive_Primary_Tool_Used_In_Adult_Cow_Breeding_Program: "",
    reproductive_Primary_Tool_Used_In_Adult_Cow_Breeding_Program_other: "",
    reproductive_additional_tools_used_in_adult_cow_breeding_program: [],
    reproductive_Primary_Tool_Used_In_Virgin_Heifer_Program: "",
    reproductive_Primary_Tool_Used_In_Virgin_Heifer_Program_other: "",
    reproductive_additional_tools_used_in_virgin_heifer_program: [],
    reproductive_record_of_sires: "Yes",
    reproductive_record_breed_dates: "Yes",
    reproductive_cows_designated_do_not_breed: "Yes",
    reproductive_record_non_breed_heat_dates: "No",
    reproductive_pregnancy_exam_frequency: "",
    reproductive_primary_method_used_to_determine_pregnancy: "",
    reproductive_calving_results_recorded_with_details: "Yes",
    reproductive_calving_difficulty_scores_recorded: "Yes",
    reproductive_herd_replacement_obtained_method: "",
    reproductive_replacement_records_same_Software: "Yes",
    reproductive_reuse_lactating_cow_ids_within_1_year: "Yes",
    reproductive_voluntary_waiting_period: 65,
    weaning_day: 60,

    // Supllement Questions
    supplemental_producer_uses_full_anion_supplementation: "Yes",
    supplemental_producer_uses_feed_additives: "Yes",
    supplemental_milk_cooperative: "",
    supplemental_programs: [],
    supplemental_dairy_fte_employees: "",
    supplemental_years_since_last_major_expansion: "",
    supplemental_years_until_next_major_expansion: "",
    supplemental_producer_works_with_purina_specialist: "Yes",

    // Facilities and Grouping 
    facilties_and_grouping_far_off_dry: false,
    facilties_and_grouping_close_up_dry: false,
    facilties_and_grouping_single_group_for_dry_cows: false,
    facilties_and_grouping_post_fresh_lactating_cows: false,
    facilties_and_grouping_lactating_rations: false,

    facilties_and_grouping_far_off_dry_form: {},
    facilties_and_grouping_close_up_dry_form: {},
    facilties_and_grouping_single_group_for_dry_cows_form: {},
    facilties_and_grouping_post_fresh_lactating_cows_form: {},
    facilties_and_grouping_lactating_rations_form: {},

    // Peer Group
    // peer_group_milk_production_lower_limit:"",
    // peer_group_milk_production_upper_limit:"",
    // peer_group_herd_size_lower_limit:"",
    // peer_group_milk_herd_size_upper_limit:"",
    // peer_group_region_lower_limit:"",
    // peer_group_region_upper_limit:"",
    // peer_group_breeds:[],
    // software_Report_National_Averages_Or_Herd_Goals:"National Averages",

    // Subherd_Report
    Adult_facility_form_primary_feed_delivery_system_chip: [],
    comments: ""
}

export let sourcleapplicationoptions = [{
    name: "DC305",
    value: "DC305"
}, {
    name: "PCDART",
    value: "PCDART"
}, {
    name: "DPLAN",
    value: "DPLAN"
}, {
    name: "DRMS DHIA",
    value: "DRMS"
}]

export const appConstants = { LoginSessionKey: 'LoginSessionKey', UserInfo: 'UserInfo', Internal: 'internal', External: 'external' }

export const defaultreportlayoutsetting = {
    "sections": [
        {
            "name": "All Cows",
            "show": true,
            "rows": [
                {
                    "name": "Head",
                    "show": true
                },
                {
                    "name": "Milk_Test_Date",
                    "show": true
                },
                {
                    "name": "Summit_Milk",
                    "show": true
                },
                {
                    "name": "Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "ECM",
                    "show": true
                },
                {
                    "name": "Management_Milk_Level",
                    "show": true
                },
                {
                    "name": "Peak_Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "Days_to_Peak_Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "Early_Slope",
                    "show": true
                },
                {
                    "name": "Percent_Greater_Than_100_Lbs_Milk",
                    "show": true
                },
                {
                    "name": "Average_DIM",
                    "show": true
                },
                {
                    "name": "Current_305_ME",
                    "show": true
                },
                {
                    "name": "First_Month_305_ME",
                    "show": true
                },
                {
                    "name": "Percent_Fat",
                    "show": true
                },
                {
                    "name": "Percent_Protein",
                    "show": true
                },
                {
                    "name": "Latest_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Management_Level_Milk",
                    "show": true
                },
                {
                    "name": "Peak_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Days_to_Peak_Weekly_Milk",
                    "show": true
                }
            ]
        },
        {
            "name": "Lactation 1 Cows",
            "show": true,
            "rows": [
                {
                    "name": "Head",
                    "show": true
                },
                {
                    "name": "Summit_Milk",
                    "show": true
                },
                {
                    "name": "Less_30_DIM",
                    "show": true
                },
                {
                    "name": "31_to_60",
                    "show": true
                },
                {
                    "name": "61_to_90",
                    "show": true
                },
                {
                    "name": "91_to_120",
                    "show": true
                },
                {
                    "name": "121_to_150",
                    "show": true
                },
                {
                    "name": "151_to_180",
                    "show": true
                },
                {
                    "name": "181_to_210",
                    "show": true
                },
                {
                    "name": "211_to_240",
                    "show": true
                },
                {
                    "name": "241_to_270",
                    "show": true
                },
                {
                    "name": "271_to_300",
                    "show": true
                },
                {
                    "name": "Greater_300",
                    "show": true
                },
                {
                    "name": "Milk_Week_2",
                    "show": true
                },
                {
                    "name": "Milk_Week_4",
                    "show": true
                },
                {
                    "name": "Milk_Week_8",
                    "show": true
                },
                {
                    "name": "Milk_Week_15",
                    "show": true
                },
                {
                    "name": "Milk_Week_21",
                    "show": true
                },
                {
                    "name": "Milk_Week_25",
                    "show": true
                },
                {
                    "name": "Milk_Week_32",
                    "show": true
                },
                {
                    "name": "Milk_Week_37",
                    "show": true
                },
                {
                    "name": "Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "ECM",
                    "show": true
                },
                {
                    "name": "Management_Milk_Level",
                    "show": true
                },
                {
                    "name": "Peak_Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "Days_to_Peak_Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "Latest_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Management_Level_Milk",
                    "show": true
                },
                {
                    "name": "Peak_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Days_to_Peak_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Early_Slope",
                    "show": true
                },
                {
                    "name": "Average_DIM",
                    "show": true
                },
                {
                    "name": "Current_305_ME",
                    "show": true
                },
                {
                    "name": "First_Month_305_ME",
                    "show": true
                },
                {
                    "name": "Percent_Fat",
                    "show": true
                },
                {
                    "name": "Percent_Protein",
                    "show": true
                },
                {
                    "name": "Latest_Weekly_Milk_Percent_L3_Plus",
                    "show": true
                },
                {
                    "name": "ECM_Percent_L3_Plus",
                    "show": true
                },
                {
                    "name": "Management_Level_Milk_Percent_L3_Plus",
                    "show": true
                },
                {
                    "name": "Peak_Weekly_Milk_Percent_L3_Plus",
                    "show": true
                },
                {
                    "name": "Test_Day_Milk_Percent_L3_Plus",
                    "show": true
                },
                {
                    "name": "Summit_Milk_Percent_L3_Plus",
                    "show": true
                },
                {
                    "name": "ECM_Percent_L3_Plus",
                    "show": true
                },
                {
                    "name": "Days_To_Peak_Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "Peak_Test_Day_Milk_Percent_L3_Plus",
                    "show": true
                },
            ]
        },
        {
            "name": "Lactation 2 Cows",
            "show": true,
            "rows": [
                {
                    "name": "Head",
                    "show": true
                },
                {
                    "name": "Summit_Milk",
                    "show": true
                },
                {
                    "name": "Less_30_DIM",
                    "show": true
                },
                {
                    "name": "31_to_60",
                    "show": true
                },
                {
                    "name": "61_to_90",
                    "show": true
                },
                {
                    "name": "91_to_120",
                    "show": true
                },
                {
                    "name": "121_to_150",
                    "show": true
                },
                {
                    "name": "151_to_180",
                    "show": true
                },
                {
                    "name": "181_to_210",
                    "show": true
                },
                {
                    "name": "211_to_240",
                    "show": true
                },
                {
                    "name": "241_to_270",
                    "show": true
                },
                {
                    "name": "271_to_300",
                    "show": true
                },
                {
                    "name": "Greater_300",
                    "show": true
                },
                {
                    "name": "Milk_Week_2",
                    "show": true
                },
                {
                    "name": "Milk_Week_4",
                    "show": true
                },
                {
                    "name": "Milk_Week_8",
                    "show": true
                },
                {
                    "name": "Milk_Week_15",
                    "show": true
                },
                {
                    "name": "Milk_Week_21",
                    "show": true
                },
                {
                    "name": "Milk_Week_25",
                    "show": true
                },
                {
                    "name": "Milk_Week_32",
                    "show": true
                },
                {
                    "name": "Milk_Week_37",
                    "show": true
                },
                {
                    "name": "Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "ECM",
                    "show": true
                },
                {
                    "name": "Management_Milk_Level",
                    "show": true
                },
                {
                    "name": "Peak_Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "Days_to_Peak_Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "Latest_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Management_Level_Milk",
                    "show": true
                },
                {
                    "name": "Peak_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Days_to_Peak_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Early_Slope",
                    "show": true
                },
                {
                    "name": "Average_DIM",
                    "show": true
                },
                {
                    "name": "Current_305_ME",
                    "show": true
                },
                {
                    "name": "First_Month_305_ME",
                    "show": true
                },
                {
                    "name": "Percent_Fat",
                    "show": true
                },
                {
                    "name": "Percent_Protein",
                    "show": true
                }
            ]
        },
        {
            "name": "Lactation 3+ Cows",
            "show": true,
            "rows": [
                {
                    "name": "Head",
                    "show": true
                },
                {
                    "name": "Summit_Milk",
                    "show": true
                },
                {
                    "name": "Less_30_DIM",
                    "show": true
                },
                {
                    "name": "31_to_60",
                    "show": true
                },
                {
                    "name": "61_to_90",
                    "show": true
                },
                {
                    "name": "91_to_120",
                    "show": true
                },
                {
                    "name": "121_to_150",
                    "show": true
                },
                {
                    "name": "151_to_180",
                    "show": true
                },
                {
                    "name": "181_to_210",
                    "show": true
                },
                {
                    "name": "211_to_240",
                    "show": true
                },
                {
                    "name": "241_to_270",
                    "show": true
                },
                {
                    "name": "271_to_300",
                    "show": true
                },
                {
                    "name": "Greater_300",
                    "show": true
                },
                {
                    "name": "Milk_Week_2",
                    "show": true
                },
                {
                    "name": "Milk_Week_4",
                    "show": true
                },
                {
                    "name": "Milk_Week_8",
                    "show": true
                },
                {
                    "name": "Milk_Week_15",
                    "show": true
                },
                {
                    "name": "Milk_Week_21",
                    "show": true
                },
                {
                    "name": "Milk_Week_25",
                    "show": true
                },
                {
                    "name": "Milk_Week_32",
                    "show": true
                },
                {
                    "name": "Milk_Week_37",
                    "show": true
                },
                {
                    "name": "Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "ECM",
                    "show": true
                },
                {
                    "name": "Management_Milk_Level",
                    "show": true
                },
                {
                    "name": "Peak_Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "Days_to_Peak_Test_Day_Milk",
                    "show": true
                },
                {
                    "name": "Latest_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Management_Level_Milk",
                    "show": true
                },
                {
                    "name": "Peak_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Days_to_Peak_Weekly_Milk",
                    "show": true
                },
                {
                    "name": "Early_Slope",
                    "show": true
                },
                {
                    "name": "Average_DIM",
                    "show": true
                },
                {
                    "name": "Current_305_ME",
                    "show": true
                },
                {
                    "name": "First_Month_305_ME",
                    "show": true
                },
                {
                    "name": "Percent_Fat",
                    "show": true
                },
                {
                    "name": "Percent_Protein",
                    "show": true
                }
            ]
        },
        {
            "name": "Component Analysis",
            "show": true,
            "rows": [
                {
                    "name": "Total_Lbs_Fat_Protein",
                    "show": true
                },
                {
                    "name": "Total_Lbs_Fat_Protein_Lactation_1",
                    "show": true
                },
                {
                    "name": "Total_Lbs_Fat_Protein_Lactation_2",
                    "show": true
                },
                {
                    "name": "Total_Pounds_of_Fat_and_Protein_Lactation_3+",
                    "show": true
                },
                {
                    "name": "Total_Lbs_Fat_Protein_Less_30_DIM",
                    "show": true
                },
                {
                    "name": "Total_Lbs_Fat_Protein_31_to_60_DIM",
                    "show": true
                },
                {
                    "name": "Total_Lbs_Fat_Protein_61_to_90_DIM",
                    "show": true
                },
                {
                    "name": "Total_Lbs_Fat_Protein_91_to_120_DIM",
                    "show": true
                },
                {
                    "name": "Total_Lbs_Fat_Protein_121_to_200_DIM",
                    "show": true
                },
                {
                    "name": "Total_Lbs_Fat_Protein_Greater_200_DIM",
                    "show": true
                },
                {
                    "name": "Percent_1st_Fat_Test_Greater_5_5",
                    "show": true
                },
                {
                    "name": "Percent_1st_Fat_Test_Greater_5_5_Lactation_1",
                    "show": true
                },
                {
                    "name": "Percent_1st_Fat_Test_Greater_5_5_Lactation_2",
                    "show": true
                },
                {
                    "name": "Percent_1st_Fat_Test_Greater_5_5_Lactation_3",
                    "show": true
                }
            ]
        },
        {
            "name": "Reproduction",
            "show": true,
            "rows": [
                {
                    "name": "Number_Pregnant",
                    "show": true
                },
                {
                    "name": "Percent_Pregnant",
                    "show": true
                },
                {
                    "name": "Percent_Herd_Coded_DNB",
                    "show": true
                },
                {
                    "name": "Percent_Herd_Coded_DNB_This_Period",
                    "show": true
                },
                {
                    "name": "Number_Open_Eligible",
                    "show": true
                },
                {
                    "name": "Percent_Pregnant_Vet_Check_Last_20_Days",
                    "show": true
                },
                {
                    "name": "Percent_Herd_Diagnosed_Pregnant_Last_30_Days",
                    "show": true
                },
                {
                    "name": "Days_Open_Pregnant_Cows",
                    "show": true
                },
                {
                    "name": "Number_Not_Bred_Greater_80_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Not_Bred_Greater_80_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Eligible_Cows_Bred",
                    "show": true
                },
                {
                    "name": "Percent_Eligible_Cows_Not_Bred",
                    "show": true
                },
                {
                    "name": "Average_DIM_1st_Service",
                    "show": true
                },
                {
                    "name": "Percent_Pregnant_Days_Open_Greater_180",
                    "show": true
                },
                {
                    "name": "Percent_New_Pregnant_Days_Open_Greater_180",
                    "show": true
                },
                {
                    "name": "Percent_New_Pregnant_Days_Open_Greater_Than_180",
                    "show": true
                },
                {
                    "name": "Percent_Open_Eligible_Days_Open_Greater_180",
                    "show": true
                },
                {
                    "name": "Percent_Pregnant_150_DIM",
                    "show": true
                },
                {
                    "name": "Percent_New_Pregnant_150_DIM",
                    "show": true
                },
                {
                    "name": "Number_Pregnant_115_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Pregnant_115_DIM",
                    "show": true
                },
                {
                    "name": "Percent_New_Pregnant_115_DIM",
                    "show": true
                },
                {
                    "name": "1st_Service_Conception_Rate",
                    "show": true
                },
                {
                    "name": "Recent_First_Service_Conception_Rate",
                    "show": true
                },
                {
                    "name": "Services_Per_Conception",
                    "show": true
                },
                {
                    "name": "Recent_Services_per_Conception",
                    "show": true
                },
                {
                    "name": "Services_Per_Aminal",
                    "show": true
                },
                {
                    "name": "Conception_Rate",
                    "show": true
                },
                {
                    "name": "Recent_Conception_Rate",
                    "show": true
                },
                {
                    "name": "Calving_Interval_Fresh_Cows",
                    "show": true
                },
                {
                    "name": "Projected_Calving_Interval_Recent_Pregnant",
                    "show": true
                },
                {
                    "name": "Min_Projected_Calving_Interval",
                    "show": true
                }
            ]
        },
        {
            "name": "Health",
            "show": true,
            "rows": [
                {
                    "name": "Number_Retained_Placenta",
                    "show": true
                },
                {
                    "name": "Percent_Retained_Placenta",
                    "show": true
                },
                {
                    "name": "Number_Metritis",
                    "show": true
                },
                {
                    "name": "Percent_Metritis",
                    "show": true
                },
                {
                    "name": "Number_Displaced_Abomasum_Fresh_Cows",
                    "show": true
                },
                {
                    "name": "Percent_Displaced_Abomasum_Fresh_Cows",
                    "show": true
                },
                {
                    "name": "DIM_Displaced_Abomasum_Fresh_Cows",
                    "show": true
                },
                {
                    "name": "Number_Displaced_Abomasum_All_Cows",
                    "show": true
                },
                {
                    "name": "Percent_Displaced_Abomasum_All_Cows",
                    "show": true
                },
                {
                    "name": "DIM_Displaced_Abomasum_All_Cows",
                    "show": true
                },
                {
                    "name": "Number_Milk_Fever",
                    "show": true
                },
                {
                    "name": "Percent_Milk_Fever",
                    "show": true
                },
                {
                    "name": "Number_Ketosis",
                    "show": true
                },
                {
                    "name": "Percent_Ketosis",
                    "show": true
                },
                {
                    "name": "Number_Lame",
                    "show": true
                },
                {
                    "name": "Percent_Lame",
                    "show": true
                },
                {
                    "name": "Number_Foottrim",
                    "show": true
                },
                {
                    "name": "Percent_Foottrim",
                    "show": true
                },
                {
                    "name": "Number_Dystocia",
                    "show": true
                },
                {
                    "name": "Percent_Dystocia",
                    "show": true
                },
                {
                    "name": "Number_Mastitis",
                    "show": true
                },
                {
                    "name": "Percent_Mastitis",
                    "show": true
                },
                {
                    "name": "Number_Uterine_Problem",
                    "show": true
                },
                {
                    "name": "Percent_Uterine_Problem",
                    "show": true
                },
                {
                    "name": "Number_Abortions",
                    "show": true
                },
                {
                    "name": "Number_Bloat",
                    "show": true
                },
                {
                    "name": "Number_Bloat_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Bloat_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Bloat_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Bloat_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Diarrhea",
                    "show": true
                },
                {
                    "name": "Number_Diarrhea_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Diarrhea_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Diarrhea_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Diarrhea_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Hernia",
                    "show": true
                },
                {
                    "name": "Number_Hernia_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Hernia_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Hernia_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Hernia_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Injury",
                    "show": true
                },
                {
                    "name": "Number_Injury_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Injury_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Injury_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Injury_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Lameness",
                    "show": true
                },
                {
                    "name": "Number_Lameness_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Lameness_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Lameness_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Lameness_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Mycoplasma",
                    "show": true
                },
                {
                    "name": "Number_Mycoplasma_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Mycoplasma_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Mycoplasma_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Mycoplasma_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Navel_3",
                    "show": true
                },
                {
                    "name": "Number_Navel_3_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Navel_3_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Navel_3_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Navel_3_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Pneumonia",
                    "show": true
                },
                {
                    "name": "Number_Pneumonia_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Pneumonia_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Pneumonia_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Pneumonia_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Undetermined",
                    "show": true
                },
                {
                    "name": "Number_Undetermined_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Undetermined_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Undetermined_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Undetermined_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Bloat_0_To_Weaning_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Bloat_0_To_Weaning_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Bloat_Weaning_Days_To_120_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Bloat_Weaning_Days_To_120_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Bloat_120_Days_To_180_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Bloat_120_Days_To_180_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Bloat_Bred_Heifers_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Bloat_Bred_Heifers_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Navel",
                    "show": true
                },
                {
                    "name": "Number_Navel_0_To_Weaning_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Navel_0_To_Weaning_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Navel_Weaning_Days_To_120_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Navel_Weaning_Days_To_120_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Navel_120_Days_To_180_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Navel_120_Days_To_180_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Navel_Bred_Heifers_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Navel_Bred_Heifers_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Injury_0_To_Weaning_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Injury_0_To_Weaning_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Injury_Weaning_Days_To_120_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Injury_Weaning_Days_To_120_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Injury_120_Days_To_180_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Injury_120_Days_To_180_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Injury_Bred_Heifers_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Injury_Bred_Heifers_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Lameness_0_To_Weaning_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Lameness_0_To_Weaning_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Lameness_Weaning_Days_To_120_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Lameness_Weaning_Days_To_120_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Lameness_120_Days_To_180_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Lameness_120_Days_To_180_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Lameness_Bred_Heifers_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Lameness_Bred_Heifers_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Brd",
                    "show": true
                },
                {
                    "name": "Number_Brd_0_To_Weaning_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Brd_0_To_Weaning_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Brd_0_To_Weaning_Days_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Brd_Weaning_Days_To_120_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Brd_Weaning_Days_To_120_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Brd_Weaning_Days_To_120_Days_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Brd_120_Days_To_180_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Brd_120_Days_To_180_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Brd_120_Days_To_180_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Brd_180_Days_To_Breeding_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Brd_180_Days_To_Breeding_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Brd_180_Days_To_Breeding_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Brd_Bred_Heifers_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Brd_Bred_Heifers_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Brd_Bred_Heifers_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Scours",
                    "show": true
                },
                {
                    "name": "Number_Scours_0_To_Weaning_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Scours_0_To_Weaning_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Scours_0_To_Weaning_Days_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Scours_Weaning_Days_To_120_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Scours_Weaning_Days_To_120_Days_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Scours_Weaning_Days_To_120_Days_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Scours_120_Days_To_180_Days_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Scours_120_Days_To_180_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Scours_120_Days_To_180_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Scours_180_Days_To_Breeding_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Scours_180_Days_To_Breeding_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Scours_180_Days_To_Breeding_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Scours_Bred_Heifers_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Scours_Bred_Heifers_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Scours_Bred_Heifers_Event_Count",
                    "show": true
                },
                {
                    "name": "Number_Bloat_180_Days_To_Breeding_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Bloat_180_Days_To_Breeding_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Navel_180_Days_To_Breeding_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Navel_180_Days_To_Breeding_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Injury_180_Days_To_Breeding_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Injury_180_Days_To_Breeding_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Lameness_180_Days_To_Breeding_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Lameness_180_Days_To_Breeding_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Scours_180_Days_To_Breeding_Initial_Case",
                    "show": true
                },
                {
                    "name": "Number_Scours_180_Days_To_Breeding_Recurrence",
                    "show": true
                },
                {
                    "name": "Number_Scours_180_Days_To_Breeding_Event_Count",
                    "show": true
                },
            ]
        },
        {
            "name": "Milk Quality",
            "show": true,
            "rows": [
                {
                    "name": "Number_New_Clinicals_Fresh",
                    "show": true
                },
                {
                    "name": "Percent_New_Clinicals_Fresh",
                    "show": true
                },
                {
                    "name": "Number_New_Clinicals_All",
                    "show": true
                },
                {
                    "name": "Percent_New_Clinicals_All",
                    "show": true
                },
                {
                    "name": "Percent_New_Chronic_All",
                    "show": true
                },
                {
                    "name": "SCC",
                    "show": true
                },
                {
                    "name": "SCC_Lactation_1",
                    "show": true
                },
                {
                    "name": "SCC_Lactation_2",
                    "show": true
                },
                {
                    "name": "SCC_Lactation_3",
                    "show": true
                },
                {
                    "name": "SCC_Less_30_DIM",
                    "show": true
                },
                {
                    "name": "SCC_Less_30_DIM_Lactation_1",
                    "show": true
                },
                {
                    "name": "SCC_Less_30_DIM_Lactation_2",
                    "show": true
                },
                {
                    "name": "SCC_Less_30_DIM_Lactation_3",
                    "show": true
                },
                {
                    "name": "SCC_Dried_Cows",
                    "show": true
                },
                {
                    "name": "SCC_Lactation_1_Dried_Cows",
                    "show": true
                },
                {
                    "name": "SCC_Lactation_2_Dried_Cows",
                    "show": true
                },
                {
                    "name": "SCC_Lactation_3_Dried_Cows",
                    "show": true
                },
                {
                    "name": "Percent_SCC_Less_50",
                    "show": true
                },
                {
                    "name": "Percent_SCC_Less_50_Lactation_1",
                    "show": true
                },
                {
                    "name": "Percent_SCC_Less_50_Lactation_2",
                    "show": true
                },
                {
                    "name": "Percent_SCC_Less_Than_50_Lactation_3+",
                    "show": true
                },
                {
                    "name": "Percent_SCC_50_to_200",
                    "show": true
                },
                {
                    "name": "Percent_SCC_50_to_200_Lactation_1",
                    "show": true
                },
                {
                    "name": "Percent_SCC_50_to_200_Lactation_2",
                    "show": true
                },
                {
                    "name": "Percent_SCC_50_to_200_Lactation_3",
                    "show": true
                },
                {
                    "name": "Percent_SCC_200_to_400",
                    "show": true
                },
                {
                    "name": "Percent_SCC_200_to_400_Lactation_1",
                    "show": true
                },
                {
                    "name": "Percent_SCC_200_to_400_Lactation_2",
                    "show": true
                },
                {
                    "name": "Percent_SCC_200_to_400_Lactation_3",
                    "show": true
                },
                {
                    "name": "Percent_SCC_400_to_800",
                    "show": true
                },
                {
                    "name": "Percent_SCC_400_to_800_Lactation_1",
                    "show": true
                },
                {
                    "name": "Percent_SCC_400_to_800_Lactation_2",
                    "show": true
                },
                {
                    "name": "Percent_SCC_400_to_800_Lactation_3",
                    "show": true
                },
                {
                    "name": "Percent_SCC_Greater_800",
                    "show": true
                },
                {
                    "name": "Percent_SCC_Greater_800_Lactation_1",
                    "show": true
                },
                {
                    "name": "Percent_SCC_Greater_800_Lactation_2",
                    "show": true
                },
                {
                    "name": "Percent_SCC_Greater_800_Lactation_3",
                    "show": true
                }
            ]
        },
        {
            "name": "Herd Inventory",
            "show": true,
            "rows": [
                {
                    "name": "Number_Milking",
                    "show": true
                },
                {
                    "name": "Number_Dry",
                    "show": true
                },
                {
                    "name": "Percent_Milking",
                    "show": true
                },
                {
                    "name": "Percent_Dry",
                    "show": true
                },
                {
                    "name": "Percent_1st_Calf_Heifers",
                    "show": true
                },
                {
                    "name": "Age_1st_Calving",
                    "show": true
                },
                {
                    "name": "Number_Fresh",
                    "show": true
                },
                {
                    "name": "Number_Dried",
                    "show": true
                },
                {
                    "name": "Number_Fresh_Gone",
                    "show": true
                },
                {
                    "name": "Percent_Heifers_Fresh",
                    "show": true
                },
                {
                    "name": "Average_Days_Dry_Fresh_Cows",
                    "show": true
                },
                {
                    "name": "Percent_Fresh_Dry_Days_Less_30",
                    "show": true
                },
                {
                    "name": "Percent_Fresh_Dry_Days_Less_40",
                    "show": true
                },
                {
                    "name": "Percent_Fresh_Dry_Days_Greater_70",
                    "show": true
                },
                {
                    "name": "Projected_Days_Dry_Dried_Cows",
                    "show": true
                },
                {
                    "name": "Number_Milking_Lactation_1",
                    "show": true
                },
                {
                    "name": "Number_Dry_Lactation_1",
                    "show": true
                }
            ]
        },
        {
            "name": "Calves",
            "show": true,
            "rows": [
                {
                    "name": "Number_Heifers_Born",
                    "show": true
                },
                {
                    "name": "Number_Bulls_Born",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Calves",
                    "show": true
                },
                {
                    "name": "Number_Sets_Twins",
                    "show": true
                },
                {
                    "name": "Percent_Twinning",
                    "show": true
                },
                {
                    "name": "Percent_Born_Dead",
                    "show": true
                },
                {
                    "name": "Number_Heifers_Dead",
                    "show": true
                },
                {
                    "name": "Number_Bulls_Dead",
                    "show": true
                },
                {
                    "name": "Number_Dairy_Heifer_Born",
                    "show": true
                },
                {
                    "name": "Number_Dairy_Beef_Heifer_Born",
                    "show": true
                },
                {
                    "name": "Number_Dairy_Bulls_Born",
                    "show": true
                },
                {
                    "name": "Number_Dairy_Beef_Bulls_Born",
                    "show": true
                },
                {
                    "name": "Percent_Dairy_Heifer_Calves",
                    "show": true
                },
                {
                    "name": "Number_Set_Of_Dairy_Twins",
                    "show": true
                },
                {
                    "name": "Number_Set_Of_Dairy_Beef_Twins",
                    "show": true
                },
                {
                    "name": "Number_Dairy_Heifer_Dead",
                    "show": true
                },
                {
                    "name": "Number_Dairy_Beef_Heifer_Dead",
                    "show": true
                },
                {
                    "name": "Number_Dairy_Bulls_Dead",
                    "show": true
                },
                {
                    "name": "Number_Dairy_Beef_Bulls_Dead",
                    "show": true
                }
            ]
        },
        {
            "name": "Heifer Enterprise",
            "show": true,
            "rows": [
                {
                    "name": "Number_In_Development",
                    "show": true
                },
                {
                    "name": "Number_Less_3_Months",
                    "show": true
                },
                {
                    "name": "Number_3_to_5_Months",
                    "show": true
                },
                {
                    "name": "Number_6_to_8_Months",
                    "show": true
                },
                {
                    "name": "Number_9_to_11_Months",
                    "show": true
                },
                {
                    "name": "Number_12_to_13_Months",
                    "show": true
                },
                {
                    "name": "Number_Greater_14_Months",
                    "show": true
                },
                {
                    "name": "Age_1st_Breeding",
                    "show": true
                },
                {
                    "name": "Percent_pregnant",
                    "show": true
                },
                {
                    "name": "services_per_conception",
                    "show": true
                },
                {
                    "name": "annual_cull_rate",
                    "show": true
                },
                {
                    "name": "annual_death_rate",
                    "show": true
                },
                {
                    "name": "Number_Less_1_Month",
                    "show": true
                },
                {
                    "name": "Number_1_to_2_Months",
                    "show": true
                },
                {
                    "name": "Number_2_to_3_Months",
                    "show": true
                },
                {
                    "name": "Age_1st_Breeding",
                    "show": true
                },
                {
                    "name": "Age_At_Conception",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_Breeding_Code",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_Standing",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_Timed",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_Double_Ovsync",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_Gnrh",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_Embryo_Transfer",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_CIDR",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_IVF",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_AI24",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_Frozen_Conv",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_Frozen_IVF",
                    "show": true
                },
                {
                    "name": "Age_At_Conception_By_Chalk",
                    "show": true
                },
                {
                    "name": "HE_First_Service_Conception_Rate",
                    "show": true
                },
                {
                    "name": "HE_Conception_Rate",
                    "show": true
                },
                {
                    "name": "Percent_bred",
                    "show": true
                },
                {
                    "name": "First_Service_Conception_Rate",
                    "show": true
                },
                {
                    "name": "Number_0_Days_To_Weaning",
                    "show": true
                },
                {
                    "name": "Number_Weaned_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Number_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Number_Bred_Heifers",
                    "show": true
                },
            ]
        },
        {
            "name": "Culling",
            "show": true,
            "rows": [
                {
                    "name": "Annual_Cull_Rate",
                    "show": true
                },
                {
                    "name": "Annual_Death_Rate",
                    "show": true
                },
                {
                    "name": "Speed",
                    "show": true
                },
                {
                    "name": "Number_Culled",
                    "show": true
                },
                {
                    "name": "Number_Culled_0_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Culled_Weaning_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Culled_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Number_Culled_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Number_Culled_Bred_Heifers",
                    "show": true
                },
                {
                    "name": "Number_Died",
                    "show": true
                }, {
                    "name": "Culled_Dry",
                    "show": true
                }, {
                    "name": "Culled_Fresh",
                    "show": true
                },
                {
                    "name": "Number_Culled_Dry",
                    "show": true
                }, {
                    "name": "Percent_Culled_DIM_Less_31_DIM",
                    "show": true
                }, {
                    "name": "Percent_Culled_DIM_31_to_60_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Less_31_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Culled_31_to_60_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Culled_61_to_90_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Culled_91_to_120_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Culled_121_to_300_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Greater_300_DIM",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Dry",
                    "show": true
                },
                {
                    "name": "Reason_Culled",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Feet_Legs",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Dairy",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Production",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Breeding",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Injury_Other",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Died",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Mastitis",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Disease",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Udder_Traits",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Unknown_Reasons",
                    "show": true
                },
                {
                    "name": "Culling_by_Lactation_Group",
                    "show": true
                },
                {
                    "name": "Speed_Lactation_1",
                    "show": true
                },
                {
                    "name": "Speed_Lactation_2",
                    "show": true
                },
                {
                    "name": "Speed_Lactation_3+",
                    "show": true
                },
                {
                    "name": "Percent_Died_Lactation_1",
                    "show": true
                },
                {
                    "name": "Percent_Died_Lactation_2",
                    "show": true
                },
                {
                    "name": "Percent_Died_Lactation_3+",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Lactation_1",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Lactation_2",
                    "show": true
                },
                {
                    "name": "Percent_Culled_Lactation_3+",
                    "show": true
                },
                {
                    "name": "Annual_Cull_Rate_Lactation_1",
                    "show": true
                },
                {
                    "name": "Annual_Death_Rate_Lactation_1",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_Less_1_Month",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_1_To_2_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_2_To_3_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_3_To_4_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_4_To_5_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_5_To_6_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_6_To_7_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_7_To_8_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_8_To_9_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_9_To_10_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_10_To_11_Months",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_In_Months_Greater_11_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_Less_1_Month",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_1_To_2_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_2_To_3_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_3_To_4_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_4_To_5_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_5_To_6_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_6_To_7_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_7_To_8_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_8_To_9_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_9_To_10_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_10_To_11_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Culled_By_Age_In_Months_Greater_11_Months",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Stillborn",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat_0_Days_To_Weaning",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat_Number_Weaned_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat_Number_Bred_Heifers",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Scours",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Scours_0_Days_To_Weaning",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Scours_Number_Weaned_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Scours_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Scours_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Scours_Number_Bred_Heifers",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_0_Days_To_Weaning",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_Number_Weaned_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_Number_Bred_Heifers",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Bloat_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Diarrhea",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Diarrhea_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Diarrhea_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Diarrhea_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Diarrhea_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Hernia",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Hernia_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Hernia_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Hernia_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Hernia_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury_0_Days_To_Weaning",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury_Number_Weaned_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury_Number_Bred_Heifers",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Injury_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness_0_Days_To_Weaning",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness_Number_Weaned_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness_Number_Bred_Heifers",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Lameness_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Mycoplasma",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Mycoplasma_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Mycoplasma_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Mycoplasma_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Mycoplasma_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_3",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_3_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_3_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_3_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Navel_3_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Pneumonia",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Pneumonia_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Pneumonia_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Pneumonia_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Pneumonia_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Undetermined",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Undetermined_2_To_30_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Undetermined_30_To_Weaning_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Undetermined_Weaning_To_90_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Undetermined_90_To_120_Days",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age",
                    "show": true
                },
                {
                    "name": "Percent_0_Days_To_Weaning",
                    "show": true
                },
                {
                    "name": "Percent_Weaned_To_120_Days",
                    "show": true
                },
                {
                    "name": "Percent_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Percent_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Percent_Bred_Heifers",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Brd",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Brd_0_Days_To_Weaning",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Brd_Number_Weaned_To_120_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Brd_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Brd_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Number_Heifer_Died_Of_Brd_Number_Bred_Heifers",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_0_Days_To_Weaning",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_Number_Weaned_To_120_Days",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_120_Days_To_180_Days",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_180_Days_To_Breeding",
                    "show": true
                },
                {
                    "name": "Percent_Heifer_Culled_By_Age_Number_Bred_Heifers",
                    "show": true
                },
            ]
        },        
        {
            "name": "Health By Month",
            "show": true,
            "rows": [
                {
                "name": "Number_Bloat",
                "show": true
                },
                {
                "name": "Number_Bloat_0_To_Weaning_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Bloat_0_To_Weaning_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Bloat_Weaning_Days_To_120_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Bloat_Weaning_Days_To_120_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Bloat_120_Days_To_180_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Bloat_120_Days_To_180_Recurrence",
                "show": true
                },
                {
                "name": "Number_Bloat_180_Days_To_Breeding_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Bloat_180_Days_To_Breeding_Recurrence",
                "show": true
                },
                {
                "name": "Number_Bloat_Bred_Heifers_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Bloat_Bred_Heifers_Recurrence",
                "show": true
                },
                {
                "name": "Number_Navel",
                "show": true
                },
                {
                "name": "Number_Navel_0_To_Weaning_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Navel_0_To_Weaning_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Navel_Weaning_Days_To_120_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Navel_Weaning_Days_To_120_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Navel_120_Days_To_180_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Navel_120_Days_To_180_Recurrence",
                "show": true
                },
                {
                "name": "Number_Navel_180_Days_To_Breeding_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Navel_180_Days_To_Breeding_Recurrence",
                "show": true
                },
                {
                "name": "Number_Navel_Bred_Heifers_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Navel_Bred_Heifers_Recurrence",
                "show": true
                },
                {
                "name": "Number_Injury",
                "show": true
                },
                {
                "name": "Number_Injury_0_To_Weaning_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Injury_0_To_Weaning_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Injury_Weaning_Days_To_120_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Injury_Weaning_Days_To_120_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Injury_120_Days_To_180_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Injury_120_Days_To_180_Recurrence",
                "show": true
                },
                {
                "name": "Number_Injury_180_Days_To_Breeding_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Injury_180_Days_To_Breeding_Recurrence",
                "show": true
                },
                {
                "name": "Number_Injury_Bred_Heifers_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Injury_Bred_Heifers_Recurrence",
                "show": true
                },
                {
                "name": "Number_Lameness",
                "show": true
                },
                {
                "name": "Number_Lameness_0_To_Weaning_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Lameness_0_To_Weaning_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Lameness_Weaning_Days_To_120_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Lameness_Weaning_Days_To_120_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Lameness_120_Days_To_180_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Lameness_120_Days_To_180_Recurrence",
                "show": true
                },
                {
                "name": "Number_Lameness_180_Days_To_Breeding_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Lameness_180_Days_To_Breeding_Recurrence",
                "show": true
                },
                {
                "name": "Number_Lameness_Bred_Heifers_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Lameness_Bred_Heifers_Recurrence",
                "show": true
                },
                {
                "name": "Number_Brd",
                "show": true
                },
                {
                "name": "Number_Brd_0_To_Weaning_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Brd_0_To_Weaning_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Brd_0_To_Weaning_Days_Event_Count",
                "show": true
                },
                {
                "name": "Number_Brd_Weaning_Days_To_120_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Brd_Weaning_Days_To_120_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Brd_Weaning_Days_To_120_Days_Event_Count",
                "show": true
                },
                {
                "name": "Number_Brd_120_Days_To_180_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Brd_120_Days_To_180_Recurrence",
                "show": true
                },
                {
                "name": "Number_Brd_120_Days_To_180_Event_Count",
                "show": true
                },
                {
                "name": "Number_Brd_180_Days_To_Breeding_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Brd_180_Days_To_Breeding_Recurrence",
                "show": true
                },
                {
                "name": "Number_Brd_180_Days_To_Breeding_Event_Count",
                "show": true
                },
                {
                "name": "Number_Brd_Bred_Heifers_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Brd_Bred_Heifers_Recurrence",
                "show": true
                },
                {
                "name": "Number_Brd_Bred_Heifers_Event_Count",
                "show": true
                },
                {
                "name": "Number_Scours",
                "show": true
                },
                {
                "name": "Number_Scours_0_To_Weaning_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Scours_0_To_Weaning_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Scours_0_To_Weaning_Days_Event_Count",
                "show": true
                },
                {
                "name": "Number_Scours_Weaning_Days_To_120_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Scours_Weaning_Days_To_120_Days_Recurrence",
                "show": true
                },
                {
                "name": "Number_Scours_Weaning_Days_To_120_Days_Event_Count",
                "show": true
                },
                {
                "name": "Number_Scours_120_Days_To_180_Days_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Scours_120_Days_To_180_Recurrence",
                "show": true
                },
                {
                "name": "Number_Scours_120_Days_To_180_Event_Count",
                "show": true
                },
                {
                "name": "Number_Scours_180_Days_To_Breeding_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Scours_180_Days_To_Breeding_Recurrence",
                "show": true
                },
                {
                "name": "Number_Scours_180_Days_To_Breeding_Event_Count",
                "show": true
                },
                {
                "name": "Number_Scours_Bred_Heifers_Initial_Case",
                "show": true
                },
                {
                "name": "Number_Scours_Bred_Heifers_Recurrence",
                "show": true
                },
                {
                "name": "Number_Scours_Bred_Heifers_Event_Count",
                "show": true
                }
            ]
        },
        {
            "name": "Culling By Month",
            "show": true,
            "rows": [
                {
                "name": "Number_Heifer_Culled_By_Age_In_Months",
                "show": true
                },
                {
                "name": "Number_Culled_0_To_Weaning_Days",
                "show": true
                },
                {
                "name": "Number_Culled_Weaning_To_120_Days",
                "show": true
                },
                {
                "name": "Number_Culled_120_Days_To_180_Days",
                "show": true
                },
                {
                "name": "Number_Culled_180_Days_To_Breeding",
                "show": true
                },
                {
                "name": "Number_Culled_Bred_Heifers",
                "show": true
                },
                {
                "name": "Number_Heifer_Stillborn",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Bloat",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Bloat_0_Days_To_Weaning",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Bloat_Number_Weaned_To_120_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Bloat_120_Days_To_180_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Bloat_180_Days_To_Breeding",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Bloat_Number_Bred_Heifers",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Scours",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Scours_0_Days_To_Weaning",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Scours_Number_Weaned_To_120_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Scours_120_Days_To_180_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Scours_180_Days_To_Breeding",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Scours_Number_Bred_Heifers",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Navel",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Navel_0_Days_To_Weaning",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Navel_Number_Weaned_To_120_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Navel_120_Days_To_180_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Navel_180_Days_To_Breeding",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Navel_Number_Bred_Heifers",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Injury",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Injury_0_Days_To_Weaning",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Injury_Number_Weaned_To_120_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Injury_120_Days_To_180_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Injury_180_Days_To_Breeding",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Injury_Number_Bred_Heifers",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Lameness",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Lameness_0_Days_To_Weaning",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Lameness_Number_Weaned_To_120_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Lameness_120_Days_To_180_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Lameness_180_Days_To_Breeding",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Lameness_Number_Bred_Heifers",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Brd",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Brd_0_Days_To_Weaning",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Brd_Number_Weaned_To_120_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Brd_120_Days_To_180_Days",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Brd_180_Days_To_Breeding",
                "show": true
                },
                {
                "name": "Number_Heifer_Died_Of_Brd_Number_Bred_Heifers",
                "show": true
                }
            ]
        }

    ]
}

export const defaultchartsetting = [
    { key: "1", id: "ecmchart", name: "Energy Corrected Milk", value: true, width: "half_page" },
    { key: "2", id: "testdaymilkchart", name: "Test Day Milk", value: true, width: "half_page" },
    { key: "3", id: "lactation1chart", name: "1st Lactation", value: true, width: "half_page" },
    { key: "4", id: "lactation2chart", name: "2nd Lactation", value: true, width: "half_page" },
    { key: "5", id: "lactation3chart", name: "3rd+ Lactation", value: true, width: "half_page" },
    { key: "6", id: "herddatachart", name: "Percent Pregnant in Herd", value: true, width: "half_page" },
    { key: "7", id: "calfheiferchart", name: "1st Calf Heifer Profiles", value: true, width: "half_page" },
    { key: "8", id: "daysopenchart", name: "Days Open", value: true, width: "half_page" },
    { key: "9", id: "percentfatchart", name: "Percent Fat", value: true, width: "half_page" },
    { key: "10", id: "somaticcellchart", name: "Somatic Cell", value: true, width: "half_page" },
    { key: "11", id: "percentproteinchart", name: "Percent Protein", value: true, width: "half_page" },
    { key: "12", id: "totallbschart", name: "Total lbs fat+protein", value: true, width: "half_page" },
    { key: "13", id: "avgdimchart", name: "Average DIM", value: true, width: "half_page" },
    { key: "14", id: "calvingintervalchart", name: "Calving Intervals", value: true, width: "half_page" },
    { key: "15", id: "annualcullchart", name: "Annual Cull", value: true, width: "half_page" },
    { key: "16", id: "lactationcurvechart", name: "Lactation Curve", value: true, width: "half_page" },
];

export const defaultchartsettingwithoutlactationcurve = [
    { key: "1", id: "ecmchart", name: "Energy Corrected Milk", value: true, width: "half_page" },
    { key: "2", id: "testdaymilkchart", name: "Test Day Milk", value: true, width: "half_page" },
    { key: "3", id: "lactation1chart", name: "1st Lactation", value: true, width: "half_page" },
    { key: "4", id: "lactation2chart", name: "2nd Lactation", value: true, width: "half_page" },
    { key: "5", id: "lactation3chart", name: "3rd+ Lactation", value: true, width: "half_page" },
    { key: "6", id: "herddatachart", name: "Percent Pregnant in Herd", value: true, width: "half_page" },
    { key: "7", id: "calfheiferchart", name: "1st Calf Heifer Profiles", value: true, width: "half_page" },
    { key: "8", id: "daysopenchart", name: "Days Open", value: true, width: "half_page" },
    { key: "9", id: "percentfatchart", name: "Percent Fat", value: true, width: "half_page" },
    { key: "10", id: "somaticcellchart", name: "Somatic Cell", value: true, width: "half_page" },
    { key: "11", id: "percentproteinchart", name: "Percent Protein", value: true, width: "half_page" },
    { key: "12", id: "totallbschart", name: "Total lbs fat+protein", value: true, width: "half_page" },
    { key: "13", id: "avgdimchart", name: "Average DIM", value: true, width: "half_page" },
    { key: "14", id: "calvingintervalchart", name: "Calving Intervals", value: true, width: "half_page" },
    { key: "15", id: "annualcullchart", name: "Annual Cull", value: true, width: "half_page" },
];

export const testdayANDWeeklyMilkArray = [
    "Less_30_DIM",
    "31_to_60",
    "61_to_90",
    "91_to_120",
    "121_to_150",
    "151_to_180",
    "181_to_210",
    "211_to_240",
    "241_to_270",
    "271_to_300",
    "Greater_300",
    "Milk_Week_2",
    "Milk_Week_4",
    "Milk_Week_8",
    "Milk_Week_15",
    "Milk_Week_21",
    "Milk_Week_25",
    "Milk_Week_32",
    "Milk_Week_37",
]

export const reporttotaltestdays = {
    "snapshot": 1,
    "benchmark": 1,
    "snapsix": 1,
    "cullinghistory": 1,
    "periodcomparison": 4,
    "subherdcomparison": 1,
    "snapshotgoals": 1,
    "heiferreport": 1
}

export const reportsetting = [{
    name: "snapshot",
    totaldates: reporttotaltestdays["snapshot"],
    label: "SNAPSHOT"
}, {
    name: "benchmark",
    totaldates: reporttotaltestdays["benchmark"],
    label: "BENCHMARK"
}, {
    name: "snapsix",
    totaldates: reporttotaltestdays["snapsix"],
    label: "SNAPSIX"
}, {
    name: "cullinghistory",
    totaldates: reporttotaltestdays["cullinghistory"],
    label: "CULLING HISTORY"
}, {
    name: "periodcomparison",
    totaldates: reporttotaltestdays["periodcomparison"],
    label: "PERIOD COMPARISON"
}, {
    name: "snapshotgoals",
    totaldates: reporttotaltestdays["snapshotgoals"],
    label: "SNAPSHOT GOALS"
}, {
    name: "subherdcomparison",
    totaldates: reporttotaltestdays["subherdcomparison"],
    label: "SUB-HERD COMPARISON"
}, {
    name: "heiferreport",
    totaldates: reporttotaltestdays["heiferreport"],
    label: "YOUNG ANIMAL"
}]

export const snapshotgoalreporttext = "The Snapshot Goals report will show the most recent Snapshot report’s performance, the most recent quarterly performance, the minimum and maximum performance available for up to the previous 12 months, and the current goal setting for each parameter.  There will also be a space for you and/or the client to designate what the desired goal should be and can then be used to customize these for the client.  The report may also be useful to show the variability in performance over the last year.";

export const cullinghistoryreporttext = " The Culling History report will summarize the culling history of the herd for up to the last 12 months as long as the data are available in the records.  The report may be useful to see on initial herd setup and occasionally thereafter (maybe once or twice a year) but is probably not necessary with each Snapshot.";

export const benchmarkreporttext = "The Purina Herdview Benchmark report summarizes recent dairy herd performance. Peer data are aggregated to compare herd performance to recent data for other herds with the same breed and geography. Peer data are not specific to herd management styles and should be interpreted with caution when targeting areas that need further attention. Reports should be saved to view changes in peer performance over time.";

export const periodcomparisonreporttext = "The Period Comparison report is a report that allows the user to define report periods sequentially starting with the oldest date. Each period is displayed as an aggregation of the test dates within the selected ranges. This report is useful as proof material before and after a management change or to view the same period in a prior year.";

export const snapsixreporttext = "The Snapsix report allows the user to view a summary of up to 6 previous periods consecutively. Previously stored data uploads are required to generate a Snapsix report. This report does not include a goals column, but the final column is an   overall summary of the values for the time period reported. This report can demonstrate longer trends in data, which may be useful as proof material.";

export const snapshotreporttext = "The Purina Dairy Snapshot report summarizes recent dairy herd performance. The report is customizable to meet the specific goals for most herd management styles and can be modified to be responsive to the current level of herd performance for a variety of parameters. The report is designed to give a complete overview while quickly targeting areas that may need further attention. The report also serves as a proof development tool, automatically accumulating trends over time in the course of consistent data uploads.";

export const dc35cullingreporttext = "Culling codes may be customized in DC305, which may not match the culling reasons listed. Please confirm culling reasons descriptions in DC305 Setup prior to interpretation of these parameters. For more information, refer to the parameter tooltips in Goals.\n\nOn-farm backups may not be collected with respect to test day intervals unless data are downloaded from a dairy records processing center. Report dates reflect backup date and last test day on record is listed under Production - All Cows. Average daily milk (MAVG) will update with backup date for herds with parlor meters (assign in Herd Details). Choice of test day milk (MILK) or MAVG is available in Sub-Herd Details for herds with parlor meters. Calculations for other report parameters are always relative to backup date.";

export const subherdscomparisonreporttext = "The Sub-Herd Comparison report allows the user to compare the performance of Sub-Herds at the same test date. At least two Sub-Herds are required to generate a Sub-Herd Comparison report.";

export const heiferreporttext = "The Purina Young Animal Report summarizes recent heifer data available and recorded in on-farm software. The report is designed to quickly target areas that may need further attention.\n\nThe report includes available young animal records for heifers, bulls and dairy beef animals when clearly reported. Calf inventories include sex and beef animals based on the dam’s calving record. Young animal inventories will reflect the sum of heifers and bulls with a calf record within each age demographic, with the exception for bred heifers. Dairy beef heifers and bulls remain in the inventory as >=180 d and Not Bred until sold or died.\n\nAccurate recording of health events should be encouraged and reports for DC305 herds may be customized to support consultative efforts to improve calf health. Health events from DC305 include bloat, navel, injury, lameness, bovine respiratory disease (BRD), and scours. Pneumonia events are mapped to BRD. Avoid mapping unrelated health events to these categories to maintain clean data. Health event records for each age demographic include initial cases, recurrences for an individual animal, and total event counts within the age group. Initial and recurring cases are determined by standardized event gaps. Health event gaps are: bloat = 21 d, navel = 21 d, injury = 21 d, lameness = 21 d, BRD = 10 d, and scours = 4 d. An individual animal with a recurrence of the same event beyond the designated event gap will only show up in the recurring and total event counts in any age demographic on future reports.";

export const goal_description = {
    "All Cows": {
        "Test_Day_Milk": "average of test day milk of all milking cows\nwhere test day milk is nonzero",
        "Latest_Weekly_Milk": "average weekly milk of all milking cows where MAVG is nonzero",
        "ECM": "average of energy corrected milk of individual milking cows\n(0.327*milk+(12.95*pctf*milk)+(7.65*pctp*milk))",
        "Management_Milk_Level": "average of management level milk of all milking cows where MLM is nonzero",
        "Summit_Milk": "average of summit milk of cows with DIM less than or equal 120 where summit milk is nonzero",
        "Peak_Weekly_Milk": "average of peak weekly milk occurs in current reporting period for cows more than 30 DIM and week less than 19 (lact1) or week less than 14(lact2+)",
        "Peak_Test_Day_Milk": "average of peak test day milk occurs in current reporting period for cows greater than 40 DIM",
        "Days_to_Peak_Weekly_Milk": "Average DIM at the time when peak weekly milk is reached.  Only cows with peak weekly milk values are used to calculate this average",
        "Days_to_Peak_Test_Day_Milk": "Average DIM at the time when peak test day milk is reached. Only cows with peak test day milk values are used to calculate this average",
        "Early_Slope": "the ratio of milk production to DIM for milking cows during 7 to 45 DIM",
        "Percent_Greater_Than_100_Lbs_Milk": "the percentage of milking cows with milk production greater than 100 lbs",
        "Average_DIM": "average DIM of all milking cows in herd, we recommend no adjustment to the default goals for average DIM",
        "Current_305_ME": "average 305 Mature Equivalent for milking cows in herd",
        "First_Month_305_ME": "average first month 305 Mature Equivalent for cows less than 66 DIM",
        "Percent_Fat": "average of percentage of milk fat for all milking cows where milk fat is nonzero",
        "Percent_Protein": "average of percentage of milk protein for all milking cows where milk protein is nonzero"
    },
    "Lactation 1": {
        "Test_Day_Milk_Less_Than_30_DIM": "average milk production of cows within 1 to 30 DIM for lactation 1",
        "Test_Day_Milk_31_to_60_DIM": "average milk production of cows within 31 to 60 DIM for lactation 1",
        "Test_Day_Milk_61_to_90_DIM": "average milk production of cows within 61 to 90 DIM for lactation 1",
        "Test_Day_Milk_91_to_120_DIM": "average milk production of cows within 91 to 120 DIM for lactation 1",
        "Test_Day_Milk_121_to_150_DIM": "average milk production of cows within 121 to 150 DIM for lactation 1",
        "Test_Day_Milk_151_to_180_DIM": "average milk production of cows within 151 to 180 DIM for lactation 1",
        "Test_Day_Milk_181_to_210_DIM": "average milk production of cows within 181 to 210 DIM for lactation 1",
        "Test_Day_Milk_211_to_240_DIM": "average milk production of cows within 211 to 240 DIM for lactation 1",
        "Test_Day_Milk_241_to_270_DIM": "average milk production of cows within 241 to 270 DIM for lactation 1",
        "Test_Day_Milk_271_to_300_DIM": "average milk production of cows within 271 to 300 DIM for lactation 1",
        "Test_Day_Milk_Greater_Than_300_DIM": "average milk production of cows >300 DIM for lactation 1",
        "Milk_Week_2": "average week 2 milk for cows in lactation 1 that passed through 14 DIM at any time during the reporting period",
        "Milk_Week_4": "average week 4 milk for cows in lactation 1 that passed through 28 DIM at any time during the reporting period",
        "Milk_Week_8": "average week 8 milk for cows in lactation 1 that passed through 56 DIM at any time during the reporting period",
        "Milk_Week_15": "average week 15 milk for cows in lactation 1 that passed through 105 DIM at any time during the reporting period",
        "Milk_Week_21": "average week 21 milk for cows in lactation 1 that passed through 147 DIM at any time during the reporting period",
        "Milk_Week_25": "average week 25 milk for cows in lactation 1 that passed through 175 DIM at any time during the reporting period",
        "Milk_Week_32": "average week 32 milk for cows in lactation 1 that passed through 224 DIM at any time during the reporting period",
        "Milk_Week_37": "average week 37 milk for cows in lactation 1 that passed through 259 DIM at any time during the reporting period",
        "Test_Day_Milk": "average test day milk of milking cows where test day milk is nonzero in lactation 1",
        "Latest_Weekly_Milk": "average weekly milk of all milking cows where MAVG is nonzero in lactation 1",
        "ECM": "average energy corrected milk of individual milking cows in lactation 1\n(0.327*milk+(12.95*pctf*milk)+(7.65*pctp*milk))",
        "Management_Milk_Level": "average management level milk of milking cows where MLM is nonzero in lactation 1",
        "Summit_Milk": "average of summit milk of cows with DIM less than or equal 120 where summit milk is nonzero in lactation 1",
        "Peak_Test_Day_Milk": "average peak test day milk occurs in current reporting period for cows greater than 40 DIM in lactation 1",
        "Peak_Weekly_Milk": "average peak weekly milk occurs in current reporting period for cows more than 30 DIM and week less than 19 in lactation 1",
        "Days_to_Peak_Test_Day_Milk": "days to peak test day milk applied to same group of cows for peak test day milk",
        "Days_to_Peak_Weekly_Milk": "days to peak weekly milk applied to same group of cows for peak weekly milk",
        "Early_Slope": "the ratio of milk production to DIM for milking cows in lactation 1 during 7 to 45 DIM",
        "Average_DIM": "average DIM of all 1st lactating cows in herd, we recommend no adjustment to the default goals for average DIM",
        "Current_305_ME": "average 305 Mature Equivalent for cows in lactation 1",
        "First_Month_305_ME": "average first month 305 Mature Equivalent for cows < 66 DIM in lactation 1",
        "Percent_Fat": "average percentage of milk fat where nonzero for cows in lactation 1",
        "Percent_Protein": "average percentage of milk protein where nonzero for cows in lactation 1"
    },
    "Lactation 2": {
        "Test_Day_Milk_Less_Than_30_DIM": "average milk production of cows within 1 to 30 DIM for lactation 2",
        "Test_Day_Milk_31_to_60_DIM": "average milk production of cows within 31 to 60 DIM for lactation 2",
        "Test_Day_Milk_61_to_90_DIM": "average milk production of cows within 61 to 90 DIM for lactation 2",
        "Test_Day_Milk_91_to_120_DIM": "average milk production of cows within 91 to 120 DIM for lactation 2",
        "Test_Day_Milk_121_to_150_DIM": "average milk production of cows within 121 to 150 DIM for lactation 2",
        "Test_Day_Milk_151_to_180_DIM": "average milk production of cows within 151 to 180 DIM for lactation 2",
        "Test_Day_Milk_181_to_210_DIM": "average milk production of cows within 181 to 210 DIM for lactation 2",
        "Test_Day_Milk_211_to_240_DIM": "average milk production of cows within 211 to 240 DIM for lactation 2",
        "Test_Day_Milk_241_to_270_DIM": "average milk production of cows within 241 to 270 DIM for lactation 2",
        "Test_Day_Milk_271_to_300_DIM": "average milk production of cows within 271 to 300 DIM for lactation 2",
        "Test_Day_Milk_Greater_Than_300_DIM": "average milk production of cows >300 DIM for lactation 2",
        "Milk_Week_2": "average week 2 milk for cows in lactation 2 that passed through 14 DIM at any time during the reporting period",
        "Milk_Week_4": "average week 4 milk for cows in lactation 2 that passed through 28 DIM at any time during the reporting period",
        "Milk_Week_8": "average week 8 milk for cows in lactation 2 that passed through 56 DIM at any time during the reporting period",
        "Milk_Week_15": "average week 15 milk for cows in lactation 2 that passed through 105 DIM at any time during the reporting period",
        "Milk_Week_21": "average week 21 milk for cows in lactation 2 that passed through 147 DIM at any time during the reporting period",
        "Milk_Week_25": "average week 25 milk for cows in lactation 2 that passed through 175 DIM at any time during the reporting period",
        "Milk_Week_32": "average week 32 milk for cows in lactation 2 that passed through 224 DIM at any time during the reporting period",
        "Milk_Week_37": "average week 37 milk for cows in lactation 2 that passed through 259 DIM at any time during the reporting period",
        "Test_Day_Milk": "average test day milk of milking cows where test day milk is nonzero in lactation 2",
        "Latest_Weekly_Milk": "average weekly milk of all milking cows where MAVG is nonzero in lactation 2",
        "ECM": "average energy corrected milk of individual milking cows in lactation 2\n(0.327*milk+(12.95*pctf*milk)+(7.65*pctp*milk))",
        "Management_Milk_Level": "average management level milk of milking cows where MLM is nonzero in lactation 2",
        "Summit_Milk": "average of summit milk of cows with DIM less than or equal 120 where summit milk is nonzero in lactation 2",
        "Peak_Test_Day_Milk": "average peak test day milk occurs in current reporting period for cows greater than 40 DIM in lactation 2",
        "Peak_Weekly_Milk": "average peak weekly milk occurs in current reporting period for cows more than 30 DIM and week less than 19 in lactation 2",
        "Days_to_Peak_Test_Day_Milk": "days to peak test day milk applied to same group of cows for peak test day milk",
        "Days_to_Peak_Weekly_Milk": "days to peak weekly milk applied to same group of cows for peak weekly milk",
        "Early_Slope": "the ratio of milk production to DIM for milking cows in lactation 1 during 7 to 45 DIM",
        "Average_DIM": "average DIM of all 2nd lactating cows in herd, we recommend no adjustment to the default goals for average DIM",
        "Current_305_ME": "average 305 Mature Equivalent for cows in lactation 2",
        "First_Month_305_ME": "average first month 305 Mature Equivalent for cows < 66 DIM in lactation 2",
        "Percent_Fat": "average percentage of milk fat where nonzero for cows in lactation 2",
        "Percent_Protein": "average percentage of milk protein where nonzero for cows in lactation 2"
    },
    "Lactation 3+": {
        "Test_Day_Milk_Less_Than_30_DIM": "average milk production of cows within 1 to 30 DIM for lactation 3+",
        "Test_Day_Milk_31_to_60_DIM": "average milk production of cows within 31 to 60 DIM for lactation 3+",
        "Test_Day_Milk_61_to_90_DIM": "average milk production of cows within 61 to 90 DIM for lactation 3+",
        "Test_Day_Milk_91_to_120_DIM": "average milk production of cows within 91 to 120 DIM for lactation 3+",
        "Test_Day_Milk_121_to_150_DIM": "average milk production of cows within 121 to 150 DIM for lactation 3+",
        "Test_Day_Milk_151_to_180_DIM": "average milk production of cows within 151 to 180 DIM for lactation 3+",
        "Test_Day_Milk_181_to_210_DIM": "average milk production of cows within 181 to 210 DIM for lactation 3+",
        "Test_Day_Milk_211_to_240_DIM": "average milk production of cows within 211 to 240 DIM for lactation 3+",
        "Test_Day_Milk_241_to_270_DIM": "average milk production of cows within 241 to 270 DIM for lactation 3+",
        "Test_Day_Milk_271_to_300_DIM": "average milk production of cows within 271 to 300 DIM for lactation 3+",
        "Test_Day_Milk_Greater_Than_300_DIM": "average milk production of cows >300 DIM for lactation 3+",
        "Milk_Week_2": "average week 2 milk for cows in lactation 3+ that passed through 14 DIM at any time during the reporting period",
        "Milk_Week_4": "average week 4 milk for cows in lactation 3+ that passed through 28 DIM at any time during the reporting period",
        "Milk_Week_8": "average week 8 milk for cows in lactation 3+ that passed through 56 DIM at any time during the reporting period",
        "Milk_Week_15": "average week 15 milk for cows in lactation 3+ that passed through 105 DIM at any time during the reporting period",
        "Milk_Week_21": "average week 21 milk for cows in lactation 3+ that passed through 147 DIM at any time during the reporting period",
        "Milk_Week_25": "average week 25 milk for cows in lactation 3+ that passed through 175 DIM at any time during the reporting period",
        "Milk_Week_32": "average week 32 milk for cows in lactation 3+ that passed through 224 DIM at any time during the reporting period",
        "Milk_Week_37": "average week 37 milk for cows in lactation 3+ that passed through 259 DIM at any time during the reporting period",
        "Test_Day_Milk": "average test day milk of milking cows where test day milk is nonzero in lactation 3+",
        "Latest_Weekly_Milk": "average weekly milk of all milking cows where MAVG is nonzero in lactation 3+",
        "ECM": "average energy corrected milk of individual milking cows in lactation 3+\n(0.327*milk+(12.95*pctf*milk)+(7.65*pctp*milk))",
        "Management_Milk_Level": "average management level milk of milking cows where MLM is nonzero in lactation 3+",
        "Summit_Milk": "average of summit milk of cows with DIM less than or equal 120 where summit milk is nonzero in lactation 3+",
        "Peak_Test_Day_Milk": "average peak test day milk occurs in current reporting period for cows greater than 40 DIM in lactation 3+",
        "Peak_Weekly_Milk": "average peak weekly milk occurs in current reporting period for cows more than 30 DIM and week less than 19 in lactation 3+",
        "Days_to_Peak_Test_Day_Milk": "days to peak test day milk applied to same group of cows for peak test day milk",
        "Days_to_Peak_Weekly_Milk": "days to peak weekly milk applied to same group of cows for peak weekly milk",
        "Early_Slope": "the ratio of milk production to DIM for milking cows in lactation 1 during 7 to 45 DIM",
        "Average_DIM": "average DIM of all 3+ lactating cows in herd, we recommend no adjustment to the default goals for average DIM",
        "Current_305_ME": "average 305 Mature Equivalent for cows in lactation 3+",
        "First_Month_305_ME": "average first month 305 Mature Equivalent for cows < 66 DIM in lactation 3+",
        "Percent_Fat": "average percentage of milk fat where nonzero for cows in lactation 3+",
        "Percent_Protein": "average percentage of milk protein where nonzero for cows in lactation 3+"
    },
    "Component Analysis": {
        "Percent_1st_Fat_Test_Greater_5_5": "percentage of fat percent greater than 5.5% in cows <=30 DIM",
        "Percent_1st_Fat_Test_Greater_5_5_Lactation_1": "percentage of fat percent greater than 5.5% in 1st lactating cows <=30 DIM",
        "Percent_1st_Fat_Test_Greater_5_5_Lactation_2": "percentage of fat percent greater than 5.5% in 2nd lactating cows <=30 DIM",
        "Percent_1st_Fat_Test_Greater_5_5_Lactation_3": "percentage of fat percent greater than 5.5% in 3+ lactating cows <=30 DIM"
    },
    "Reproduction": {
        "Number_Pregnant": "number of cows pregnant in the herd",
        "Percent_Pregnant": "percentage of pregnant cows in all cows in the herd",
        "Number_Open_Eligible": "number of cows with DIM greater than vwp in open status",
        "Percent_Pregnant_Vet_Check_Last_20_Days": "percentage of cows diagnosed pregnant in all cows that had pregnancy check in current reporting period",
        "Percent_Herd_Diagnosed_Last_30_Days": "percentage of cows diagnosed pregnancy in last 30 days in all cows in the herd",
        "Days_Open_Pregnant_Cows": "average of days open for all pregnant cows",
        "Number_Not_Bred_Greater_80_DIM": "number of cows greater than 80 DIM and not bred or were bred for the first time at greater than 80 DIM during the reporting period",
        "Percent_Not_Bred_Greater_80_DIM": "percentage of cows not bred in all cows greater than 80 DIM",
        "Percent_Eligible_Cows_Bred": "percentage of cows bred in all eligible cows",
        "Percent_Eligible_Cows_Not_Bred": "percentage of cows not bred in all eligible cows",
        "Average_DIM_1st_Service": "average first insemination DIM of all milking cows",
        "Percent_New_Pregnant_Days_Open_Greater_180": "percentage of cows with days open greater than 180 in all pregnant cows",
        "Percent_New_Pregnant_Days_Open_Greater_Than_180": "percentage of cows with days open greater than 180 in all cows diagnosed pregnant in current reporting period",
        "Percent_Open_Eligible_Days_Open_Greater_180": "percentage of cows with days open greater than 180 in all eligible cows",
        "Percent_Pregnant_150_DIM": "percentage of cows with days open less than or equal 150 in all pregnant cows",
        "Percent_New_Pregnant_150_DIM": "percentage of cows with days open less than or equal 150 in all cows diagnosed pregnancy in current reporting period",
        "Number_Pregnant_115_DIM": "number of all pregnant cows in the herd with days open less than or equal 115 days",
        "Percent_Pregnant_115_DIM": "percentage of cows with days open less than or equal 115 in all pregnant cows",
        "Percent_New_Pregnant_115_DIM": "percentage of cows with days open less than or equal 115 in all cows diagnosed pregnancy in current reporting period",
        "1st_Service_Conception_Rate": "percentage of cows diagnosed pregnant after 1st time bred",
        "Recent_First_Service_Conception_Rate": "percentage of cows diagnosed pregnant in current reporting period after 1st time bred",
        "Services_Per_Conception": "average times bred of all pregnant cows",
        "Recent_Services_per_Conception": "average times bred of all cows diagnosed pregnant in current reporting period",
        "Services_Per_Aminal": "average times bred of all eligible cows",
        "Conception_Rate": "pregnant cows as percentage of total times bred",
        "Recent_Conception_Rate": "pregnant cows diagnosed in current reporting period as percentage of total times bred of these cows",
        "Calving_Interval_Fresh_Cows": "average calving interval of cows calved in current reporting period",
        "Projected_Calving_Interval_Recent_Pregnant": "average projected calving interval (=due date – calving date) of cows diagnosed pregnant in current reporting period",
        "Min_Projected_Calving_Interval": "Estimate of the minimum projected calving interval for all cows in the herd. Uses the projected calving interval for confirmed pregnant cows. Assumes:  all bred, non-pregnant cows will become pregnant on the last recorded breeding; all non-bred, non-pregnant cows with DIM greater the vwp will be bred and become pregnant in the next 30 days; all fresh cows (DIM less than vwp) will have a 13 month calving interval",
        "Percent_Herd_Coded_DNB": "percentage of ‘do not bred’ cows in all cows in the herd",
        "Percent_Herd_Coded_DNB_This_Period": "percentage of ‘do not bred’ cows in current reporting period in all cows in the herd"
    },
    "Health": {
        "Number_Retained_Placenta": "number of cows that have retained placenta in current reporting period",
        "Percent_Retained_Placenta": "percentage of cows that have retained placenta in all cows fresh in current period",
        "Number_Metritis": "number of cows that have metritis in current reporting period",
        "Percent_Metritis": "percentage of cows that have metritis in all cows calved in current period",
        "Number_Displaced_Abomasum_Fresh_Cows": "number of fresh cows (DIM<45) that have displaced abomasum in current reporting period",
        "Percent_Displaced_Abomasum_Fresh_Cows": "percentage of fresh cows that have displaced abomasum (DIM<45) in all cows calved in current period",
        "DIM_Displaced_Abomasum_Fresh_Cows": "average DIM of fresh cows (DIM<45) that have displaced abomasum in current reporting period",
        "Number_Displaced_Abomasum_All_Cows": "number of cows that have displaced abomasum in current reporting period",
        "Percent_Displaced_Abomasum_All_Cows": "cows that have displaced abomasum in last 365 days as percentage of all cows in herd. It is an estimated annual incidence rate of the occurrence of DAs in the herd.",
        "DIM_Displaced_Abomasum_All_Cows": "average DIM of cows that have DAs in current reporting period",
        "Number_Milk_Fever": "number of cows that have milk fever in current reporting period",
        "Percent_Milk_Fever": "percentage of cows that have milk fever in all cows calved in current period",
        "Number_Ketosis": "number of cows that have ketosis in current reporting period",
        "Percent_Ketosis": "percentage of cows that have ketosis in all cows calved in current period",
        "Number_Lame": "number of cows that have lame in current reporting period",
        "Percent_Lame": "cows that have lame in last 365 days as percentage of all cows in herd. It is an estimated annual incidence rate of the occurrence of lameness in the herd",
        "Number_Foot_Trim": "number of cows that have foot trim in current reporting period",
        "Percent_Foot_Trim": "cows that have foot trim in last 365 days as percentage of all cows in the herd. It is an estimated annual incidence rate of the occurrence of foot trimming in the herd.",
        "Number_Dystocia": "number of cows that have dystocia (calving ease >2) in current reporting period",
        "Percent_Dystocia": "percentage of cows that have dystocia in all cows calved in current period",
        "Number_Mastitis": "number of cows that have mastitis in current reporting period",
        "Percent_Mastitis": "percentage of cows that have mastitis in all cows calved in current period",
        "Number_Uterine_Problem": "number of cows that have uterine problem in current reporting period",
        "Percent_Uterine_Problem": "percentage of cows that have uterine problem in all cows calved in current period",
        "Number_Abortions": "number of cows that have abortion in current reporting period"
    },
    "Milk Quality": {
        "Number_New_Clinicals_Fresh": "DC305: number of cows less than 45 DIM that got first mastitis in current reporting period\n\nPCDART: number of cows calved in current period with scc>200 and previous scc<200",
        "Percent_New_Clinicals_Fresh": "New Clinical Mastitis - Fresh Cows as percentage of cows calved in current period",
        "Number_New_Clinicals_All": "DC305: number of cows that got first mastitis in current reporting period\n\nPCDART: number of milking cows with scc>200 and previous scc<200",
        "Percent_New_Clinicals_All": "cows that got first mastitis in last 365 days as percentage of total milking plus dry cows. It is an estimate of the annual incidence rate of the occurrence of new clinical mastitis cases in the herd",
        "Percent_New_Chronic_All": "cows that got three or more mastitis in last 365 days as percentage of total milking plus dry cows. An estimate of the annual incidence rate of the occurrence of mastitis cases in the herd that are classified as chronic (two or more cases in a lactation)",
        "SCC_Dried_Cows": "for DC305, this value only populates if dry date > test date",
        "SCC_Lactation_1_Dried_Cows": "for DC305, this value only populates if dry date > test date",
        "SCC_Lactation_2_Dried_Cows": "for DC305, this value only populates if dry date > test date",
        "SCC_Lactation_3_Dried_Cows": "for DC305, this value only populates if dry date > test date",

    },
    "Herd Inventory": {
        "Number_Milking": "number of milking cows in the herd",
        "Percent_Milking": "number of milking cows as percentage of all cows in the herd",
        "Number_Dry": "number of dry cows in the herd",
        "Percent_Dry": "number of dry cows as percentage of all cows in the herd",
        "Percent_1st_Calf_Heifers": "cows at 1st lactation as percentage of all cows in the herd",
        "Age_1st_Calving": "average age at calving for 1st lactation cows",
        "Number_Fresh": "number of cows that calved in current reporting period",
        "Number_Dried": "number of cows that were dried in current reporting period",
        "Number_Fresh_Gone": "number of cows that calved in current period are culled",
        "Percent_Heifers_Fresh": "of the cows that calved current period, the percent of them that were 1st calf heifers",
        "Average_Days_Dry_Fresh_Cows": "average previous dry days of 2+ lactation cows that calved in current reporting period",
        "Percent_Fresh_Dry_Days_Less_30": "2+ lactation fresh cows with previous dry days less than 30 as percentage of all 2+ lactation fresh cows in current period",
        "Percent_Fresh_Dry_Days_Less_40": "2+ lactation fresh cows with previous dry days less than 40 as percentage of all 2+ lactation fresh cows in current period",
        "Percent_Fresh_Dry_Days_Greater_70": "2+ lactation fresh cows with previous dry days greater than 70 as percentage of all 2+ lactation fresh cows in current period",
        "Projected_Days_Dry_Dried_Cows": "average projected dry days (due date- dry date) for cows were dried in current period",            
    },
    "Calves": {
        "Number_Heifers_Born": "number of heifers born (either dead or alive) in current period",
        "Number_Bulls_Born": "number of bulls born (either dead or alive) in current period",
        "Percent_Heifer_Calves": "heifers as percentage of all calves born in current period",
        "Number_Sets_Twins": "number of twins born in current period",
        "Percent_Twinning": "calvings resulted in twins as percentage of all calvings in current period",
        "Percent_Born_Dead": "dead calves as percentage of all calves born in current period",
        "Number_Heifers_Dead": "number of dead heifers in current period",
        "Number_Bulls_Dead": "number of dead bulls in current period",        
    },
    "Heifer Enterprise": {
        "Number_In_Development": "number of heifers in the records",
        "Number_Less_3_Months": "number of heifers in records that were less than 3 months of age",
        "Number_3_to_5_Months": "number of heifers in records that were from 3 to 5 months of age",
        "Number_6_to_8_Months": "number of heifers in records that were from 6 to 8 months of age ",
        "Number_9_to_11_Months": "number of heifers in records that were from 9 to 11 months of age",
        "Number_12_to_13_Months": "number of heifers in records that were from 12 to 14 months of age",
        "Number_Greater_14_Months": "number of heifers in records that were greater than 14 months of age",
        "Age_1st_Breeding": "average age (as month) of heifers received first breeding",
        "Percent_pregnant": "pregnant heifers as percentage of heifers received breeding",
        "services_per_conception": "average services of pregnant heifers",
        "annual_cull_rate": "number of heifers left the herd in last 365 days as percentage of total heifers in development",
        "annual_death_rate": "number died in last 365 days as percentage of total heifers in development",
    },
    "Culling": {
        "Annual_Cull_Rate": "cows left the herd in last 365 days as percentage of all cows in the herd at the backup time ",
        "Annual_Death_Rate": "cows died in last 365 days as percentage of all cows in the herd at the backup time",
        "Speed": "an annualized culling speed based on the culling that occurred during the period being reviewed",
        "Number_Culled": "number of cows culled in current reporting period",
        "Number_Died": "number of cows died in current reporting period",
        "Percent_Culled_DIM_Less_31_DIM": "fresh cows <=30 DIM culled in current reporting period as percentage of all cows calved at the same period",
        "Percent_Culled_DIM_31_to_60_DIM": "fresh cows 31 to 60 DIM culled in current reporting period as percentage of all cows calved at the same period",
        "Percent_Culled_Less_31_DIM": "cows <=30 DIM culled in current period as percentage of all cows in the herd at the backup time ",
        "Percent_Culled_31_to_60_DIM": "cows 31 to 60 DIM culled in current period as percentage of all cows in the herd at the backup time ",
        "Percent_Culled_61_to_90_DIM": "cows 61 to 90 DIM culled in current period as percentage of all cows in the herd at the backup time ",
        "Percent_Culled_91_to_120_DIM": "cows 91 to 120 DIM culled in current period as percentage of all cows in the herd at the backup time ",
        "Percent_Culled_121_to_300_DIM": "cows 121 to 300 DIM culled in current period as percentage of all cows in the herd at the backup time ",
        "Percent_Culled_Greater_300_DIM": "cows >300 DIM culled in current period as percentage of all cows in the herd at the backup time ",
        "Percent_Culled_Dry": "dry cows culled in current period as percentage of all cows in the herd at the backup time ",
        "Percent_Culled_Feet_Legs": "cows culled in current period for reason 1(pcdart, defined by user in dc305 and dplan) as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Dairy": "cows culled in current period for reason 2(pcdart, defined by user in dc305 and dplan) as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Production": "cows culled in current period for reason 3(pcdart, defined by user in dc305 and dplan) as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Breeding": "cows culled in current period for reason 4(pcdart, defined by user in dc305 and dplan) as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Injury_Other": "cows culled in current period for reason 5(pcdart, defined by user in dc305 and dplan) as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Died": "cows culled in current period for reason 6 as percentage of all cows in the herd at the backup time (defined by user in dplan)",
        "Percent_Culled_Mastitis": "cows culled in current period for reason 7(pcdart, defined by user in dc305 and dplan) as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Disease": "cows culled in current period for reason 8(pcdart, defined by user in dc305 and dplan) as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Udder_Traits": "cows culled in current period for reason 9(pcdart, defined by user in dc305 and dplan) as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Unknown_Reasons": "cows culled in current period for unknow reasons as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Lactation_1": "1st lactating cows culled in current period as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Lactation_2": "2nd lactating cows culled in current period as percentage of all cows in the herd at the backup time",
        "Percent_Culled_Lactation_3+": "3+ lactating cows culled in current period as percentage of all cows in the herd at the backup time",
        "Speed_Lactation_1": "1st lactating cows culled in last 365 days as percentage of total 1st lactating cow",
        "Speed_Lactation_2": "2nd lactating cows culled in last 365 days as percentage of total 2nd lactating cow",
        "Speed_Lactation_3+": "3+ lactating cows culled in last 365 days as percentage of total 3+ lactating cow",
        "Percent_Died_Lactation_1": "1st lactating cows died in current period as percentage of all cows in the herd at the backup time ",
        "Percent_Died_Lactation_2": "2nd lactating cows die in current period as percentage of all cows in the herd at the backup time ",
        "Percent_Died_Lactation_3+": "3+ lactating cows die in current period as percentage of all cows in the herd at the backup time ",        
    }
}

export const non_editable_component_analysis = [
    "Total_Lbs_Fat_Protein",
    "Total_Lbs_Fat_Protein_Lactation_1",
    "Total_Lbs_Fat_Protein_Lactation_2",
    "Total_Pounds_of_Fat_and_Protein_Lactation_3+",
    "Total_Lbs_Fat_Protein_Less_30_DIM",
    "Total_Lbs_Fat_Protein_31_to_60_DIM",
    "Total_Lbs_Fat_Protein_61_to_90_DIM",
    "Total_Lbs_Fat_Protein_91_to_120_DIM",
    "Total_Lbs_Fat_Protein_121_to_200_DIM",
    "Total_Lbs_Fat_Protein_Greater_200_DIM"
]

export const table_headers = [
    "Reason_Culled", "Culling_by_Lactation_Group", "Culled_Dry", "Culled_Fresh", "Number_Culled_Dry",
    "Number_Bloat", "Number_Diarrhea", "Number_Hernia", "Number_Injury", "Number_Lameness", "Number_Mycoplasma",
    "Number_Navel_3", "Number_Pneumonia", "Number_Undetermined", "Percent_Heifer_Culled_By_Age_In_Months",
    "Percent_Heifer_Culled_By_Age", "Number_Heifer_Culled_By_Age_In_Months", "Number_Navel", "Number_Brd", "Number_Scours",
    "Number_Heifer_Died_Of_Bloat", "Number_Heifer_Died_Of_Scours", "Number_Heifer_Died_Of_Navel", "Number_Heifer_Died_Of_Injury",
    "Number_Heifer_Died_Of_Lameness", "Number_Heifer_Died_Of_Brd"
]

export const row_subheader = [
    "Number_Bloat", "Number_Diarrhea", "Number_Hernia", "Number_Injury", "Number_Lameness", "Number_Mycoplasma",
    "Number_Navel_3", "Number_Pneumonia", "Number_Undetermined", "Percent_Heifer_Culled_By_Age_In_Months",
    "Percent_Heifer_Culled_By_Age", "Number_Heifer_Culled_By_Age_In_Months", "Number_Navel", "Number_Brd", "Number_Scours",
    "Number_Heifer_Died_Of_Bloat", "Number_Heifer_Died_Of_Scours", "Number_Heifer_Died_Of_Navel", "Number_Heifer_Died_Of_Injury",
    "Number_Heifer_Died_Of_Lameness", "Number_Heifer_Died_Of_Brd", "Number_Culled"
]

export const legal_agreement_eula = {
    "title": "End User License Agreement",
    "logo": "/logo-addie-teal.png",
    "logoAlt": "Addie Insights Logo",   
    "agreeText": "I Agree",
    "disagreeText": "Cancel",
    "downloadText": "Download",
    "downloadURL": "/documents/AddiePortalEULA-Rev2025.05.01.pdf",
    "version": 1.0,
    "legalText": `<div style="text-align:left;"><h5 style="text-align:center">End User License Agreement</h5><br/>

<p>THIS END USER LICENSE AGREEMENT  (“Agreement”) is a binding agreement between the you (“you”, “your”) 
and Land O’Lakes, Inc., a Minnesota corporation with a place of business at 4001 Lexington Ave. N., Arden Hills, 
Minnesota 55126, together with its affiliates, subsidiaries, and related entities (collectively referred to as “Land 
O’Lakes”, “we”, “us”, or “our”).</p>
 
<p>If you are representing your organization, you are accepting this Agreement for yourself and on behalf of 
your organization. You represent that you have full authority to bind your organization to this Agreement.</p>

<p>This Agreement will be effective when you indicate your assent as a clickthrough, or other accepted means 
of assent, to this Agreement, or when incorporated by reference into another agreement, or when you 
access or use the Portal (defined below), or as this Agreement may be presented to you multiple times in 
writing or electronically prior to and as you use our Portal including as web page links.</p>

<p>We may change this Agreement at any time. By continuing to access or use the Portal you agree to be 
bound by the most recent version of this Agreement. Please frequently check www.addieinsights.com/EULA 
to find the most recent version of this Agreement which applies to you.</p>

<p>For good and valuable consideration, the receipt and sufficiency of which is hereby acknowledged, the parties 
agree to the foregoing and as follows:</p>
<ol type="1"> 
<li>
	1. <u>Definitions.</u>
	<ol type="a">
		<li>
		a) “Additional Terms” means the Privacy Notice and Terms of Use found at https://www.landolakesinc.com, as 
		may be amended from time to time. 
		</li>
		<li>
		b) “Authorized User” means Retailers and their employees, consultants, contractors, and agents who are a party 
		to this Agreement, and authorized by Land O’Lakes to use the Portal accessed with the requisite 
		Credentials issued by Land O’Lakes. Each Authorized User shall have unique Credentials.  
		</li>
		<li>
		c) “Confidential Information” means confidential and proprietary information disclosed or made accessible by 
		a party to the other party hereunder including without limitation information accessed via the Portal 
		(including Reports), information related to the functions and features of the Portal including information 
		about future releases, functions or features of the Portal or any Reports. Confidential Information excludes 
		information which: (i) is available to the public prior to disclosure to the receiving party or becomes available 
		to the public by publication or otherwise without fault of the receiving party; (ii) is lawfully in the receiving 
		party’s possession prior to the initial disclosure; (iii) is supplied to the receiving party by a third party having 
		a legal right to so disclose; or (iv) is independently developed by receiving party without use of the 
		disclosing party’s Confidential Information. 
		</li>
		<li>
		d) “Credentials” means a unique Land O’Lakes issued Business Link user ID to authorize users of the Portal. 
		</li>
		<li>
		e) “Data” means information shared by you with Land O’Lakes for use with the Portal and any information 
		otherwise uploaded, submitted to the Portal by you or on your behalf, and other information which may be 
		Revision 5/01/2025   
		collected and otherwise collected from you by passive/automatic means via your use of the Portal, if any. 
		</li>
		<li>
		f) “De-Identified Data” means Personal Information from which identifiable elements have been removed, such 
		that the resulting data elements can no longer be used to identify any specific person, including without 
		limitation aggregated Personal Information.  
		</li>
		<li>
		g) “Documentation” means all written or electronic user guides and other materials related to the use of the 
		Portal, including any updates thereto. Reports are not Documentation. 
		</li>
		<li>
		h) “Land O’Lakes IP” means the Portal, Reports, any other content or data originating from Land O’Lakes 
		(and/or its Providers defined below), including without limitation De-Identified Data, Aggregated Data, 
		Usage Data, Documentation, the software, hardware, systems, materials, processes, know-how, derivative 
		works, and the like utilized by and developed in the provision of the Portal, including interfaces and APIs, 
		Land O’Lakes’ trademarks, logos and service marks, and all goodwill therein, and all error corrections, 
		updates, enhancements, modifications, improvements, derivative works, changes, customizations and 
		components in any of the foregoing, and all intellectual property rights therein. 
		</li>
		<li>
		i) “Member” means the Land O’Lakes member-owner who is a party to a membership agreement with Land 
		O’Lakes. 
		</li>
		<li>
		j) “Permitted Use” means uses only for your internal business purposes without disclosing or sharing any, 
		Land O’Lakes IP, Reports or Confidential Information to third parties and subject to the terms of this 
		Agreement. Your internal business purposes may include providing, at the request of Producers, Reports in 
		PDF form only, defined below, to veterinarians or financial institutions relevant to the business needs of 
		Producers. 
		</li>
		<li>
		k) “Person” means an individual or an entity, as applicable in each circumstance where referenced. 
		</li>
		<li>
		l) “Personal Information” means information that relates to an identified or identifiable natural person. 
		</li>
		<li>
		m) “Portal” means the web user interface and related systems which is the subject of this Agreement as it 
		currently exists and any successor user interface or related system that may exist that replaces or may be 
		combined with it. 
		</li>
		<li>
		n) “Producer” means an organization operating one or more dairy farms. Producers may or may not also be 
		Members (defined above) under this agreement. 
		</li>
		<li>
		o) “Reports” means Land O’Lakes reports generated and delivered through use of the Portal or otherwise 
		provided by Land O’Lakes. 
		</li>
		<li>
		p) “Retailers” means animal nutrition and feed suppliers who are selling, marketing, or distributing goods to 
		Producers. A Retailer may or may not also be a Member. 
		</li>
		<li>
		q) “Services Agreement” means any services agreement outside this Agreement between you and Land 
		O’Lakes, if any. This Agreement controls with respect to the use of the Portal, provision of Data and 
		otherwise the subject matter related to this Agreement. 
		</li>
		<li>
		r) “Usage Data” means any statistical and usage data derived or generated from the performance, operation 
		and use of the Portal (including the Reports), and all analysis thereof, including the review and interpretation 
		of how individuals engage with content or data published, posted, uploaded, transmitted, generated or 
		otherwise provided through or via the Portal. 
		</li>
	</ol>
</li>
<li>
	2. <u>License To Portal.</u>
	<ol type="a">
		<li>
		2.1. License. Land O’Lakes hereby grants you a limited, non-exclusive, non-transferable, non-sublicensable 
		license, solely for Permitted Uses, to the Portal and Reports to: (a) access and use the Portal in the United 
		States of America; and (b) access, download, copy and use the Reports, and disclose and share the Reports, in 
		each case subject to confidentiality and limits on use as set forth herein, including ensuring the disclaimer 
		and proprietary notices on the Reports are recreated on all copies of the Reports. LAND O’LAKES MAKES NO 
		GUARANTEES, EXPRESS OR IMPLIED, AS TO THE ACCURACY OF INFORMATION OR ANALYSIS CONTAINED 
		IN THE REPORTS. 
		</li>
		<li>
		2.2. Restrictions On Use. You will not and will not permit any third party to, except as expressly permitted 
		under Section 2.1: (a) extract data from the Portal except via Reports subject to the restrictions herein, extract 
		or copy data from the Reports, or remove the disclaimers or proprietary notices indicating the source, 
		limitations and intellectual property rights with respect to the Reports; (b) copy, modify or create any 
		derivative works based on the Land O’Lakes IP, including making derivative works based on the Reports; (c) 
		license, sublicense, sell, resell, rent, lease, transfer, assign, distribute, time share, offer in a service bureau, or 
		otherwise make the Land O’Lakes IP available to any third party, including sharing the Reports or any other 
		Land O’Lakes IP with any third party for any purpose; (d) use or share the Portal, Reports, or any other Land 
		O’Lakes IP outside of the Permitted Use; (e) decipher, disassemble, reverse engineer or decompile any portion 
		of the Land O’Lakes IP; (f) access the Land O’Lakes IP in order to build any commercially available product or 
		service; or (g) except as agreed in a separate written agreement with Land O’Lakes, incorporate, merge or 
		interface the Portal (including any Reports) or any other Land O’Lakes IP into any third party or self
		developed products or to allow any such products to access the Land O’Lakes IP, in whole or in part, or 
		incorporate, merge or interface data generated by the Portal or contained in Reports with or into other 
		software or other products or services for any purposes. For clarity, this means you cannot include 
		Reports in any other materials. Except for the limited rights and licenses expressly granted in this 
		Agreement, nothing in this Agreement grants, by implication, waiver, estoppel or otherwise, any right, 
		title, or interest in or to the Portal or other Land O’Lakes IP. 
		</li>
		<li>
		2.3. Authorized Use. The Portal shall only be accessed and used by Authorized Users. Each Authorized User 
		shall control against unauthorized access by users, and maintain the confidentiality of Credentials, 
		Confidential Information, and other account information. You are solely responsible for all aspects of any 
		user transaction, interaction with, or other use of the Portal and any acts of your use of the Portal. You will 
		immediately notify Land O’Lakes of any known or suspected security incident resulting or possibly resulting 
		in the unauthorized use, access or theft of a password, name, account or Personal Information or any other 
		breach of security that materially compromises the confidentiality, integrity or accessibility of the Portal, the 
		Reports. LAND O’LAKES IS NOT LIABLE FOR ANY LOSSES CAUSED BY ANY UNAUTHORIZED USE. 
		</li>
		<li>
		2.4. Third-Party Providers. Land O’Lakes engages or otherwise collaborates with third parties, including its 
		affiliates, contractors, subcontractors, consultants, vendors, partners, Members and advisors (collectively, 
		“Providers”), including who support/manage Land O’Lakes’ services and marketing initiatives, supplement, 
		enhance, support, or host the Portal, or with whom Land O’Lakes collaborates which may offer other 
		solutions. You understand that as part of such engagements Providers may have access to and use of certain 
		Data, Reports, and other Confidential Information. You agree that Land O’Lakes may provide Data, Reports 
		and other Confidential Information to such Providers as permitted in this Agreement or the Services 
		Agreement. 
		</li>
		<li>
		2.5. Third Party Technology. The Portal may include technology or data subject to third party licenses 
		(collectively, “Third Party Technology”). In the event Land O’Lakes’ rights to provide any Third Party 
		Technology are terminated, expire, or are otherwise diminished, you understand and agree that Land 
		O’Lakes may cease to include the applicable Third Party Technology in the Portal and may terminate the 
		Revision 5/01/2025   
		affected functionality in, or of, the Portal with or without notice to you. LAND O’LAKES WILL HAVE NO 
		LIABILITY WHATSOEVER TO YOU WITH RESPECT TO ANY DIMINISHMENT IN THE PORTAL RESULTING FROM 
		LAND O’LAKES’ REDUCED ABILITY TO PROVIDE THIRD PARTY TECHNOLOGY. 
		</li>
		<li>
		2.6. Your Obligations. In addition to your obligations under any Services Agreement, you will cooperate 
		with Land O’Lakes as reasonably requested by Land O’Lakes. If you fail to provide such assistance, then Land 
		O’Lakes will have no obligation to provide the Portal (or the Reports). 
		<li>
		3. <u>IP And Data.</u>
			<li>
			3.1. Land O’Lakes IP. Land O’Lakes and Providers own all right, title, and interest in and to the Land O’Lakes 
			IP. You will not act in any way which may impair Land O’Lakes’ rights in and to the Land O’Lakes IP. Notwithstanding 
			anything to the contrary, if you or your personnel provide any ideas, suggestions or recommendations (even 
			if designated as your Confidential Information)  regarding the Portal or any products or services from Land 
			O’Lakes, Land O’Lakes IP, or Land O’Lakes’ Confidential Information ( collectively “Feedback”), you have 
			granted and hereby grant Land O’Lakes, its affiliates and Providers the right to retain, use, incorporate and 
			disclose, on a perpetual and irrevocable basis, such Feedback without payment of royalties or other 
			consideration and such right is fully transferable and sublicensable. 
			</li>
			<li>
			3.2. Data. You agree that in addition to any rights you grant or have granted via the Additional Terms, you 
			have granted, and you hereby grant to Land O’Lakes a non-exclusive, perpetual, irrevocable, royalty-free, 
			paid up, worldwide, transferable, and sublicensable license to:  
				<ol>
					<li>
					a) host, access, use, disclose, reproduce, upload, analyze, manipulate, modify, create derivative works of, 
					transmit, distribute, disclose, combine with other data, display, make available, and otherwise process 
					Data for Land O’Lakes’ business purposes (as may be determined in Land O’Lakes’ sole discretion) 
					including without limitation: (i) in connection with the operation of the Portal (including the generation 
					of  Reports); (ii) generate information and insights from products offered by prospective or existing third 
					party service providers by Land O’Lakes; (iii) support or manage Land O’Lakes’ marketing initiatives or 
					services to you or other third parties; (iv) share or disclose to third parties for business purposes; (v) to 
					perform research and development of new or existing products and services; (vii) to test, populate, 
					improve, or enhance Reports or other tools and applications and develop new tools and applications for 
					Land O’Lakes or third parties; (viii) perform services for you or third parties; (ix) create derivative works; 
					(x) combine Data with other data or analysis to generate derived data or insights; and (xi) for legal and 
					regulatory compliance. 
					</li>
					<li>
					b) disclose and use the Data for Land O’Lakes’ and its affiliates’ business purposes including: (i) to generate 
					information from products offered by third-party service or technology solution providers that are 
					integrated with the Portal via application programming interface or otherwise and to enhance or 
					supplement the Portal; (ii) to or with Providers assisting with the Portal or who support or manage Land 
					O’Lakes’ or its affiliates’ services and marketing initiatives, supplement, enhance, support, or host the 
					Portal, provide services and other forms of support directly to you, or with whom Land O’Lakes or its 
					affiliates collaborate which may offer other solutions to you; (iii) to or with Land O’Lakes’ or its affiliates’ 
					customers which use such data for their business purposes; (iv) to perform research and development of 
					products and services; (v) to test, populate, improve, or enhance the Portal (including the Reports or Land 
					O’Lakes’, its affiliates’ or its Providers’ other tools and applications and develop new tools and 
					applications; (vi) to inform your business decisions; (vii) to provide to you Data concerning your 
					operations; (viii) to perform support and other services for your benefit; (ix) as set forth in a Services 
					Agreement; and (x) to perform legal and regulatory compliance; and 
					</li> 
					<li>
					c) de-identify Data in order to create De-Identified Data and use such De-Identified Data or aggregate such 
					De-Identified Data with other data or analysis to generate Aggregated Data. You further agree that (i) 
					Land O’Lakes exclusively owns all such De-Identified Data and Aggregated Data, as well as any 
					information derived therefrom, (which are collectively, Land O’Lakes IP) (but excluding non-public Data 
					provided hereunder), (ii) Land O’Lakes may use the De-Identified Data and Aggregated Data for any 
					purpose, either directly through Land O’Lakes or indirectly through affiliates and Providers and Land 
					O’Lakes’ other vendors, partners and customers; and (iii) we may freely utilize information concerning you 
					which is lawfully obtained by us via sources other than you.
					</li>  
				</ol>
			</li>
		</li>
		<li>
		4. <u>Compensation.</u> Any fees due in relation to this Agreement are as quoted in the applicable Services 
		Agreement, if any. 
		</li>
		<li>
		5. <u>Confidential Information.</u> Each party shall protect the other party’s Confidential Information from 
		unauthorized use or disclosure (as provided by this Agreement) using no less than reasonable measures. The 
		receiving party will not disclose the Confidential Information to any third party except (a) for Land O’Lakes, to 
		its affiliates and Providers and their respective employees, contractors and agents, and (b) for you, to your 
		Users, (“Representatives”), who have a need to know such information, are informed of the confidential 
		nature of such information, and agree to be bound by obligations of confidentiality substantially similar to 
		those set forth in this Agreement. The receiving party will use the Confidential Information solely and 
		exclusively for the purpose of performing or receiving the benefits of this Agreement. If the receiving party is 
		required by law or court order to disclose the Confidential Information, the receiving party will give the 
		disclosing party prompt notice of such requirement so that an appropriate protective order or other relief 
		may be sought. The breach, or threatened breach, of any provision of this Section, or the breach of license 
		rights or restrictions or other misuse of Confidential Information may cause irreparable harm to the other 
		party without an adequate remedy at law. Upon any such breach, violation, or infringement, or threat 
		thereof, a party will be entitled to seek injunctive relief to prevent the other party from commencing or 
		continuing any action constituting such breach, violation, or infringement, without having to post a bond or 
		other security, and without having to prove the inadequacy of other available remedies. This Section does 
		not limit any other remedy available to either party. This Section does not modify the scope of any 
		rights granted in this Agreement including Additional Terms. Except as otherwise provided in this 
		Agreement, upon request of return and destruction, the receiving party will return to the disclosing 
		party and thereafter destroy all Confidential Information and provide the disclosing party written 
		certification attesting to its destruction. 
		</li>
		<li>
		6. <u>Representations And Warranties.</u> You represent, warrant and covenant that: (a) all Data or Personal 
		Information was and will be true and correct to the best of your knowledge; (b) you are the lawful owner or 
		licensee of all Data or Personal Information, you have the full legal right to share such Data or Personal 
		Information and grant the licenses under this Agreement any Services Agreement between the parties (c), 
		you have provided and will provide all notices and obtained adequate consents as may be required by 
		applicable law to lawfully provide to Land O’Lakes any Data or Personal Information; (d) there is no claim, 
		litigation or proceeding pending or threatened against you with respect to Data or Personal information 
		alleging, and no use of the Data or Personal Information as permitted herein will result in, the violation, 
		misappropriation or infringement of any right, including any intellectual property rights, of any person or 
		entity; and (e) you will comply with all applicable laws, regulations and orders in your use of the Portal, 
		including the Reports. 
		</li>
		<li>
		7. <u>DISCLAIMER.</u> LAND O’LAKES DOES NOT MAKE ANY REPRESENTATIONS OR WARRANTIES WHATSOEVER 
		WITH RESPECT TO THE PORTAL OR REPORTS. LAND O’LAKES EXPRESSLY EXCLUDES AND DISCLAIMS ANY 
		WARRANTIES, WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING, WITHOUT LIMITATION, THE 
		IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON- 
		INFRINGEMENT AND WARRANTIES ARISING FROM COURSE OF DEALING, COURSE OF PERFORMANCE AND 
		USAGE OF TRADE. LAND O’LAKES DOES NOT WARRANT THAT ACCESS TO, OR OPERATION OF, THE 
		PORTAL WILL BE UNINTERRUPTED, SECURE OR ERROR-FREE, THAT ALL ERRORS WILL BE CORRECTED, OR 
		THAT THE PORTAL WILL SATISFY YOUR OR ANY THIRD PARTY’S REQUIREMENTS OR COMPLY WITH ALL 
		LAWS. LAND O’LAKES UTILIZES THE INTERNET TO PROVIDE THE PORTAL. YOU ACKNOWLEDGE THAT THE 
		FLOW OF TRAFFIC OVER THE INTERNET DEPENDS IN LARGE PART ON SERVICES PROVIDED OR 
		CONTROLLED BY THIRD PARTIES, WHICH CAN ALSO IMPAIR OR DISRUPT YOUR CONNECTIONS TO THE 
		INTERNET (OR PORTIONS THEREOF), AND CERTAIN PERFORMANCE QUALITIES OF THE PORTAL. LAND 
		O’LAKES DISCLAIMS ANY AND ALL LIABILITY, RESULTING FROM OR RELATED TO INTERNET CONNECTIVITY. 
		</li>
		<li>
		8. <u>Indemnification.</u> You will defend, indemnify and hold harmless Land O’Lakes and its affiliates, and their 
		respective employees, officers, and directors against all reasonable attorney’s fees, expert fees, costs 
		(including costs related to the provision of notices to customers and consumers), and expenses and all 
		liability, losses and damages arising in connection with: (a) the violation, infringement or misappropriation 
		by the Data or Personal Information, or use thereof, of any third party’s rights including but not limited to 
		intellectual property rights or privacy rights; (b) your negligence, willful misconduct, or breach of this 
		Agreement; (c) any claims brought by any user or other third party alleging unauthorized use or disclosure 
		of Data or Personal Information, or otherwise claiming that you failed to obtain proper consent to use or 
		disclose Data or Personal Information for use and disclosure as contemplated herein; or (d) your use or 
		misuse of the Portal including the Reports.  
		</li>
		<li>
		9. <u>LIMITATION OF LIABILITY.</u> LAND O’LAKES’ TOTAL CUMULATIVE LIABILITY UNDER OR RELATED TO THIS 
		AGREEMENT WILL NOT EXCEED FIVE THOUSAND DOLLARS ($5000). MULTIPLE CLAIMS WILL NOT EXTEND 
		THIS LIMIT. IN NO EVENT WILL LAND O’LAKES BE LIABLE UNDER OR RELATED TO THIS AGREEMENT FOR 
		ANY SPECIAL, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS OR LOSS 
		OF GOODWILL, LOSS OR RECONSTRUCTION OF DATA, OR COSTS FOR SUBSTITUTE GOODS. THE PARTIES 
		ACKNOWLEDGE THAT THE FOREGOING LIMITATIONS ARE A MATERIAL CONDITION FOR THEIR ENTRY 
		INTO THIS Agreement. THE FOREGOING APPLIES UNDER ANY THEORY OF LIABILITY (INCLUDING 
		CONTRACT, TORT, OR OTHERWISE), AND WHETHER OR NOT A PARTY HAS BEEN ADVISED OF THE 
		POSSIBILITY OF SUCH DAMAGES. 
		</li>
		<li>
		10. <u>Term.</u> This Agreement will continue until terminated as described below. 
		</li>
		<li>
		11. <u>Termination.</u> We may terminate this Agreement by removing your access to the Portal without notice or 
		refund to you, with or without cause, as we may determine in our sole discretion. 
		</li>
		<li>
		12. <u>Effect of Termination.</u> Upon termination you will, and will cause all your Users to, cease use of the 
		Portal and your license to the Portal will terminate. Those provisions of this Agreement that, by their 
		nature, are intended to survive the termination of this Agreement, will remain in full force and effect 
		following the termination of this Agreement. Upon termination and thereafter, Land O’Lakes is not 
		obligated to return or destroy any Data provided or Land O’Lakes IP, and you are not obligated to 
		return or destroy Reports downloaded during the term of this Agreement. Notwithstanding the 
		foregoing, the receiving party may retain one archival copy of Confidential Information that may be 
		used solely to demonstrate compliance with this Agreement, so long as the receiving party continues to 
		treat such Confidential Information pursuant to the terms of this Agreement.
		</li>
		<li>  
		13. <u>General.</u> No waiver of any breach of this Agreement and no course of dealing between the parties will be 
		Revision 5/01/2025   
		construed as a waiver of any subsequent breach of this Agreement. The provisions of this Agreement are 
		severable. If any provision of this Agreement is held to be invalid, illegal, or unenforceable, the validity, 
		legality, or enforceability of the remaining provisions will in no way be affected or impaired thereby. This 
		Agreement will be governed, interpreted, and construed in accordance with the laws of the State of 
		Minnesota without regard to the principles of conflicts of laws. Any legal action or proceeding relating to 
		this Agreement will be instituted exclusively in a state or federal court in the State of Minnesota. The parties 
		will submit to the exclusive jurisdiction of, and accept that venue is proper in, these courts in any such legal 
		action or proceeding. When executed in writing, this Agreement may be executed in multiple counterparts, 
		each of which is deemed an original, but all of which taken together constitute the same instrument. For 
		purposes of execution and delivery, each party may rely upon the electronic signature, or other electronic 
		means of indicating assent, of the other party. Land O’Lakes has the right to (as to itself) effect an 
		Assignment. “Assignment” means any purported assignment or transfer, directly or indirectly, of this 
		Agreement by a party whether a party assigns this Agreement by way of merger, license, or sale of assets to 
		which this Agreement relates, or otherwise, without notice to you. You do not have the right to effect an 
		Assignment, except with the prior express written consent of Land O’Lakes which consent may be withheld 
		in its sole and absolute discretion. This Agreement will be binding upon and inure to the benefit of the 
		parties and their respective successors and permitted assigns. Any Assignment or other purported 
		assignment in contravention of terms of this Section will be void and unenforceable. Land O’Lakes’ failure to 
		perform hereunder will be excused to the extent such performance is rendered impossible by strike, 
		pandemic (including SARS-CoV-2), fire, flood, or other act of nature, governmental acts, orders or 
		restrictions, or any other reason where failure to perform is beyond the reasonable control and not caused 
		by the negligence of Land O’Lakes. This Agreement will not be construed as creating a relationship of 
		employment, agency, partnership, joint venture, or any other form of legal association. Neither party has any 
		power to bind the other party or to assume or to create any obligation or responsibility on behalf of the 
		other party. This Agreement will not confer any rights or remedies upon any person other than the parties, 
		Land O’Lakes’ affiliates and their respective successors and permitted assigns and the Agreement. 
		indemnified parties (with respect to indemnification). Any notices provided hereunder will be in writing 
		and will be deemed to have been duly given when delivered, or three (3) days after mailing by U.S. 
		certified mail, return receipt requested, postage prepaid, addressed to the following addresses: if to 
		Land O’Lakes: Land O’Lakes, Inc., Attention: Member Relations, P.O. Box 64101, St. Paul, Minnesota 
		55164-0101 with a copy to: Land O’Lakes, Inc., Attention: Law Department – MS 2500, P.O. Box 64101, 
		St. Paul, MN 55164-0101; and, if to you: to the last address you gave us. This Agreement and the 
		Services Agreement(s) constitute the entire agreement between the parties with respect to its subject 
		matter and as of the date of agreement by you supersedes all prior or contemporaneous agreements, 
		negotiations, representations, and proposals, whether written or oral, relating to its subject matter 
		(subject to the exceptions set forth in this Agreement). Except for modifications made by us to this 
		Agreement as noted in the recitals, no modification of this Agreement and no waiver of any breach of 
		this Agreement will be effective unless in writing and signed by an authorized representative of the 
		party against whom enforcement is sought. The Uniform Computer Information Transactions Act will 
		not apply to this Agreement, or any business conducted pursuant to it, regardless of when and however 
		adopted, enacted, and amended under the Laws of any jurisdiction. Where “including” is used herein it 
		means “including but not limited to.” 
		</li>
</ol>
<p>Revision 5/01/2025</p>
</div>`
}

export const legal_agreement_milk_producer = {
    "title": "Milk Producer Data Terms and Conditions",
    "logo": "/logo-addie-teal.png",
    "logoAlt": "Addie Insights Logo",   
    "agreeText": "I Agree",
    "disagreeText": "Cancel",
    "downloadText": "Download",
    "downloadURL": "/documents/AddieMilkProducerDataAgreementRev2025.05.01.pdf",
    "version": 1.0,
    "legalText": `<div style="text-align:left;"><h5 style="text-align:center">Milk Producer Data Terms and Conditions</h5><br/>

<p>THIS MILK PRODUCER DATA AGREEMENT (“Agreement”) is a binding agreement between the you (“you”, 
“your”) and Land O’Lakes, Inc., a Minnesota corporation with a place of business at 4001 Lexington Ave. N., 
Arden Hills, Minnesota 55126, together with its affiliates, subsidiaries, and related entities (collectively referred 
to as “Land O’Lakes”, “we”, “us”, or “our”). </p>
 
<p>If you represent a Producer, defined below, you are accepting this Agreement for yourself and on behalf of 
the Producer. You represent that you have full authority to bind the Producer to this Agreement. </p>

<p>We may change this Agreement at any time. By continuing to provide Data you agree to be bound by the 
most recent version of this Agreement. Please frequently check www.addieinsights.com/DataAgreement to 
find the most recent version of this Agreement which applies to you.</p>

<p>For good and valuable consideration, the receipt and sufficiency of which is hereby acknowledged, the parties 
agree to the foregoing and as follows:</p>
<ol type="1"> 
<li>
	1. <u>Definitions.</u>
	<ol type="a">
		<li>
		a) “Additional Terms” means the Privacy Notice and Terms of Use found at 
https://www.landolakesinc.com, as may be amended from time to time, plus any Services Agreement 
in effect between the parties, if any. 
		</li>
		<li>
		b) “Confidential Information” means confidential and proprietary information disclosed or made 
accessible by a party to the other party hereunder including without limitation, Reports provided to 
you. Confidential Information excludes information which: (i) is available to the public prior to 
disclosure to the receiving party or becomes available to the public by publication or otherwise 
without fault of the receiving party; (ii) is lawfully in the receiving party’s possession prior to the 
initial disclosure; (iii) is supplied to the receiving party by a third party having a legal right to so 
disclose; or (iv) is independently developed by receiving party without use of the disclosing party’s 
Confidential Information.
		</li>
		<li>
		c) “Credentials” means a unique Land O’Lakes issued Business Link user id to authorize users of the Portal.
		</li>
		<li>
		d) “Data” means information shared by you with Land O’Lakes for use as provided by this Agreement.  
Data includes without limitation information regarding the business operations of Producers related 
to individual animals and herds, business contact information, De-Identified Data (defined below), 
locations, performance, and other information which related to your business. 
		</li>
		<li>
		e) “De-Identified Data” means Personal Information from which identifiable elements have been 
removed, such that the resulting data elements can no longer be used to identify any specific person, 
including without limitation aggregated Personal Information.
		</li>
		<li>
		f) “Land O’Lakes IP” means the Reports (defined below) any other content, data, insights, know-how, 
hardware, systems, software, applications, web portals, websites, databases, processes, materials, 
Revision 5/01/2025 
derivative works, technology, services, tools and the like produced (wholly or in part) utilized by or 
developed with use of the Data as permitted by this Agreement.  In addition, “Land O’Lakes IP” 
includes Land O’Lakes’ trademarks, logos and service marks, and all goodwill therein, and all error 
corrections, updates, enhancements, modifications, improvements, derivative works, changes, 
customizations, and components in any of the foregoing, and all intellectual property rights therein.   
		</li>
		<li>
		g) “Member” means the Land O’Lakes member-owner who is a party to a Membership and Milk 
Marketing Agreement with Land O’Lakes.
		</li>
		<li>
		h) “Permitted Use” means uses only for your internal business purposes without disclosing or sharing 
any Land O’Lakes IP, Reports or Confidential Information to third parties subject to the terms of this 
Agreement. 
		</li>
		<li>
		i) “Person” means an individual or an entity, as applicable in each circumstance where referenced.
		</li>
		<li>
		j) “Personal Information” means information that relates to an identified or identifiable natural person as 
defined by applicable privacy law.
		</li>
		<li>
		k) “Producer” means an organization operating one or more dairy farms. Producers may, or may not, also 
be Members (defined above) under this agreement.
		</li>
		<li>
		l) “Reports” means Land O’Lakes reports generated and delivered to you or third parties using the Data, 
wholly or in part, as permitted by this Agreement.
		</li>
		<li>
		m) “Services Agreement” means any services agreement outside this Agreement between you and Land 
O’Lakes, if any, including without limitation the Membership and Milk Marketing Agreement. 
		</li>		
	</ol>
</li>
<li>
	2. <u>License to Data.</u>
	<ol type="a">
		<li>
2.1. You agree that in addition to any rights you grant or have granted via the Additional Terms, you have 
granted, and you hereby grant to Land O’Lakes a non-exclusive, perpetual, irrevocable, royalty-free, paid 
up, worldwide, transferable and sublicensable license to: 
		<ol type="a">
			<li>a)host, access, use, disclose, reproduce, upload, analyze, manipulate, modify, create derivative works of, 
transmit, sell, transfer, distribute, disclose, combine with other data, display, make available, and 
otherwise process Data for Land O’Lakes’ business purposes (as may be determined in Land O’Lakes’ 
sole discretion) including without limitation: (i) provide Reports to you or third parties; (ii) generate 
information and insights using products offered by prospective or existing third party service 
providers by Land O’Lakes; (iii) support or manage Land O’Lakes’ marketing initiatives or services to 
you or other third parties; (iv) share or disclose to third parties for their business purposes; (v) to 
perform research and development of new or existing products and services; (vii) to test, populate, 
improve, or enhance Reports or other tools and applications and develop new tools and applications 
for Land O’Lakes or third parties; (viii) perform services for you or third parties; (ix) create derivative 
works; (x) combine Data with other data or analysis to generate derived data or insights; and (xi) for 
legal and regulatory compliance.</li>
<li>b) create De-Identified Data and use such De-Identified Data with other data or analysis to generate 
derived data or insights. You further agree that (i) Land O’Lakes exclusively owns all such De
Identified Data, as well as any information derived therefrom or derivative works, (which are 
collectively, Land O’Lakes IP), (ii) Land O’Lakes may use the De-Identified Data for any purpose, either 
directly through Land O’Lakes or indirectly through affiliates and Providers and Land O’Lakes’ other 
vendors, partners and customers; and (iii) we may freely utilize information concerning you which is 
lawfully obtained by us via sources other than you.</li>
		</ol>
		</li>
		<li>
2.2. You agree that the above rights are in addition to any rights you grant or have granted via any 
applicable Additional Terms. 
		</li>
		<li>
3. <u>Land O’Lakes IP.</u> Land O’Lakes owns all rights, title, and interest in and to the Land O’Lakes IP.  You will not 
act in any way which may impair Land O’Lakes’ rights in and to the Land O’Lakes IP. Notwithstanding anything to 
the contrary, if you or your personnel provide any ideas, suggestions or recommendations (even if 
designated as your Confidential Information) regarding the any products or services from Land O’Lakes, 
Land O’Lakes IP, or Land O’Lakes’ Confidential Information (collectively “Feedback”), you have granted and 
hereby grant Land O’Lakes, its affiliates and Providers the right to retain, use, incorporate and disclose, on 
a perpetual and irrevocable basis, such Feedback without payment of royalties or other consideration and 
such right is fully transferable and sublicensable.  
		</li>
		<li>
4. <u>License to Reports.</u> Land O’Lakes hereby grants you a limited, non-exclusive, non-transferable, non
sublicensable license, solely for Permitted Uses, to any Reports provided to you and to disclose and share 
the Reports, in each case subject to confidentiality and limits on use as set forth herein, including ensuring 
the disclaimer and proprietary notices on the Reports are recreated on all copies of the Reports. LAND 
O’LAKES MAKES NO GUARANTEES, EXPRESS OR IMPLIED, AS TO THE ACCURACY OF INFORMATION OR 
ANALYSIS CONTAINED IN THE REPORTS.
		</li>
		<li>
4.1. <u>Restrictions On Use.</u> You will not and will not permit any third party to, except as expressly permitted under 
Section 2.1: (a)  extract or copy data from the Reports, or remove the disclaimers or proprietary notices 
indicating the source, limitations and intellectual property rights with respect to the Reports; (b) copy, 
modify or create any derivative works based on the Land O’Lakes IP, including making derivative works 
based on the Reports; (c) license, sublicense, sell, resell, rent, lease, transfer, assign, distribute, time share, 
offer in a service bureau, or otherwise make the Land O’Lakes IP available to any third party, including 
sharing the Reports or any other Land O’Lakes IP with any third party for any purpose; (d) use or share the 
Portal, Reports, or any other Land O’Lakes IP outside of the Permitted Use; (e) decipher, disassemble, 
reverse engineer or decompile any portion of the Land O’Lakes IP; (f) access the Land O’Lakes IP in order to 
build any commercially available product or service; or (g) except as agreed in a separate written 
agreement with Land O’Lakes, incorporate, merge or interface the Reports or any other Land O’Lakes IP 
into any third party or self-developed products or to allow any such products to access the Land 
O’Lakes IP, in whole or in part, or incorporate, merge or interface data contained in Reports with or 
into other software or other products or services for any purposes. For clarity, this means you cannot 
include Reports in any other materials. Except for the limited rights and licenses expressly granted in 
this Agreement, nothing in this Agreement grants, by implication, waiver, estoppel or otherwise, any 
right, title, or interest in or to the Portal or other Land O’Lakes IP.
		</li>
		<li>
		5. <u>Compensation.</u> Any fees due in relation to this Agreement are as quoted in the applicable Services 
Agreement, if any. 
		</li>
		<li>
		6. <u>Confidential Information.</u>  Each party shall protect the other party’s Confidential Information from 
unauthorized use or disclosure (as provided by this Agreement) using no less than reasonable measures. 
The receiving party will not disclose the Confidential Information to any third party except (a) for Land 
O’Lakes, to its affiliates and Providers and their respective employees, contractors and agents, and (b) for 
you, your employees, your contractors or  your service providers who have a need to know such 
information, are informed of the confidential nature of such information, and agree to be bound by 
Revision 5/01/2025 
obligations of confidentiality substantially similar to those set forth in this Agreement. The receiving party 
will use the Confidential Information solely and exclusively for the purpose of performing or receiving the 
benefits of this Agreement. If the receiving party is required by law or court order to disclose the 
Confidential Information, the receiving party will give the disclosing party prompt notice of such 
requirement so that an appropriate protective order or other relief may be sought. The breach, or 
threatened breach, of any provision of this Section, or the breach of license rights or restrictions or other 
misuse of Confidential Information may cause irreparable harm to the other party without an adequate 
remedy at law. Upon any such breach, violation, or infringement, or threat thereof, a party will be entitled 
to seek injunctive relief to prevent the other party from commencing or continuing any action constituting 
such breach, violation, or infringement, without having to post a bond or other security, and without 
having to prove the inadequacy of other available remedies. This Section does not limit any other remedy 
available to either party. This Section does not modify the scope of any rights granted in this Agreement 
including Additional Terms. Except as otherwise provided in this Agreement, upon request of return and 
destruction, the receiving party will return to the disclosing party and thereafter destroy all Confidential 
Information and provide the disclosing party written certification attesting to its destruction.
		</li>
		<li>
		7. <u>Representations And Warranties.</u>  You represent, warrant and covenant that: (a) all Data or Personal 
Information was and will be true and correct to the best of your knowledge; (b) you are the lawful owner 
or licensee of all Data or Personal Information provided, you have the full legal right to share such Data 
or Personal Information and grant the licenses under this Agreement or any applicable Services 
Agreement between the parties (c), you have provided and will provide all notices and obtained adequate 
consents as may be required by applicable law to lawfully provide to Land O’Lakes any Data or Personal 
Information; (d) there is no claim, litigation or proceeding pending or threatened against you with respect 
to Data or Personal information alleging, and no use of the Data or Personal Information as permitted 
herein will result in, the violation, misappropriation or infringement of any right, including any intellectual 
property rights, of any person or entity; and (e) you will comply with all applicable laws, regulations and 
orders in your use of the Portal, including the Reports. 
		</li>
		<li>
		8. <u>DISCLAIMER.</u>  LAND O’LAKES DOES NOT MAKE ANY REPRESENTATIONS OR WARRANTIES WHATSOEVER 
WITH RESPECT TO THE PORTAL OR REPORTS. LAND O’LAKES EXPRESSLY EXCLUDES AND DISCLAIMS 
ANY WARRANTIES, WHETHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING, WITHOUT LIMITATION, 
THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND 
NON- INFRINGEMENT AND WARRANTIES ARISING FROM COURSE OF DEALING, COURSE OF 
PERFORMANCE AND USAGE OF TRADE. LAND O’LAKES DOES NOT WARRANT THAT ACCESS TO, OR 
OPERATION OF, THE PORTAL WILL BE UNINTERRUPTED, SECURE OR ERROR-FREE, THAT ALL ERRORS 
WILL BE CORRECTED, OR THAT THE PORTAL WILL SATISFY YOUR OR ANY THIRD PARTY’S 
REQUIREMENTS OR COMPLY WITH ALL LAWS. LAND O’LAKES UTILIZES THE INTERNET TO PROVIDE THE 
PORTAL. YOU ACKNOWLEDGE THAT THE FLOW OF TRAFFIC OVER THE INTERNET DEPENDS IN LARGE 
PART ON SERVICES PROVIDED OR CONTROLLED BY THIRD PARTIES, WHICH CAN ALSO IMPAIR OR 
DISRUPT YOUR CONNECTIONS TO THE INTERNET (OR PORTIONS THEREOF), AND CERTAIN 
PERFORMANCE QUALITIES OF THE PORTAL. LAND O’LAKES DISCLAIMS ANY AND ALL LIABILITY, 
RESULTING FROM OR RELATED TO INTERNET CONNECTIVITY.  
		</li>
		<li>
		9. <u>Indemnification.</u> You will defend, indemnify and hold harmless Land O’Lakes and its affiliates, and their 
respective employees, officers, and directors against all reasonable attorney’s fees, expert fees, costs 
(including costs related to the provision of notices to customers and consumers), and expenses and all 
liability, losses and damages arising in connection with: (a) the violation, infringement or 
misappropriation by the Data or Personal Information, or use thereof, of any third party’s rights including 
Revision 5/01/2025 
but not limited to intellectual property rights or privacy rights; (b) your negligence, willful misconduct, or 
breach of this Agreement; (c) any claims brought by any user or other third party alleging unauthorized 
use or disclosure of Data or Personal Information, or otherwise claiming that you failed to obtain proper 
consent to use or disclose Data or Personal Information for use and disclosure as contemplated herein; or 
(d) your use or misuse of the Portal including the Reports. 
		</li>
		<li>
		10. <u>LIMITATION OF LIABILITY.</u> LAND O’LAKES’ TOTAL CUMULATIVE LIABILITY UNDER OR RELATED TO THIS 
AGREEMENT WILL NOT EXCEED FIVE THOUSAND DOLLARS ($5000). MULTIPLE CLAIMS WILL NOT EXTEND 
THIS LIMIT. IN NO EVENT WILL LAND O’LAKES BE LIABLE UNDER OR RELATED TO THIS AGREEMENT FOR 
ANY SPECIAL, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS OR 
LOSS OF GOODWILL, LOSS OR RECONSTRUCTION OF DATA, OR COSTS FOR SUBSTITUTE GOODS. THE 
PARTIES ACKNOWLEDGE THAT THE FOREGOING LIMITATIONS ARE A MATERIAL CONDITION FOR THEIR 
ENTRY INTO THIS Agreement. THE FOREGOING APPLIES UNDER ANY THEORY OF LIABILITY (INCLUDING 
CONTRACT, TORT, OR OTHERWISE), AND WHETHER OR NOT A PARTY HAS BEEN ADVISED OF THE 
POSSIBILITY OF SUCH DAMAGES. 
		</li>
		<li>
		11. <u>Effective Date.</u>  This Agreement will be effective when you indicate your assent as a clickthrough, or 
other accepted means of assent, to this Agreement, or when incorporated by reference into another 
agreement, or when you access or use the Portal, or when providing Data for use as provided in this 
Agreement, or as this Agreement may be presented to you multiple times in writing or electronically 
prior to and as you use our Portal including as web page links.   
		</li>
		<li>
		12. <u>Term.</u> This Agreement will continue until terminated as described below. 
		</li>
		<li>  
		13. <u>Termination.</u> Ethier party may cease to share Data or Reports, as applicable, to the other party at any time 
as such party may determine in its sole discretion with or without notice to the other party.  
		</li>
		<li>  
		14. <u>Effect of Termination.</u>  Those provisions of this Agreement that, by their nature, are intended to survive 
the termination of this Agreement, will remain in full force and effect following the termination of this 
Agreement. Upon termination and thereafter, Land O’Lakes is not obligated to return or destroy any 
Data provided or Land O’Lakes IP, and you are not obligated to return or destroy Reports downloaded 
during the term of this Agreement. Notwithstanding the foregoing, the receiving party may retain one 
archival copy of Confidential Information that may be used solely to demonstrate compliance with this 
Agreement, so long as the receiving party continues to treat such Confidential Information pursuant to 
the terms of this Agreement.
		</li>
		<li>  
		15. <u>Controlling Terms.</u> Notwithstanding the terms of any Service Agreement or other agreement in effect 
between the parties, this Agreement controls with respect to the provision of Data and otherwise the 
subject matter related to this Agreement. 
		</li>
		<li>  
		16. <u>General.</u>  No waiver of any breach of this Agreement and no course of dealing between the parties will be 
construed as a waiver of any subsequent breach of this Agreement. The provisions of this Agreement are 
severable. If any provision of this Agreement is held to be invalid, illegal, or unenforceable, the validity, 
legality, or enforceability of the remaining provisions will in no way be affected or impaired thereby. This 
Agreement will be governed, interpreted, and construed in accordance with the laws of the State of 
Minnesota without regard to the principles of conflicts of laws. Any legal action or proceeding relating to 
this Agreement will be instituted exclusively in a state or federal court in the State of Minnesota. The 
parties will submit to the exclusive jurisdiction of, and accept that venue is proper in, these courts in any 
such legal action or proceeding. When executed in writing, this Agreement may be executed in multiple 
counterparts, each of which is deemed an original, but all of which taken together constitute the same 
instrument. For purposes of execution and delivery, each party may rely upon the electronic signature, or 
other electronic means of indicating assent, of the other party. Land O’Lakes has the right to (as to itself) 
effect an Assignment without notice to you. “Assignment” means any purported assignment or transfer, 
directly or indirectly, of this Agreement by a party whether a party assigns this Agreement by way of 
merger, license, or sale of assets to which this Agreement relates, or otherwise. You do not have the right 
to effect an Assignment, except with the prior express written consent of Land O’Lakes which consent may 
be withheld in its sole and absolute discretion. This Agreement will be binding upon and inure to the 
benefit of the parties and their respective successors and permitted assigns. Any Assignment or other 
purported assignment in contravention of terms of this Section will be void and unenforceable. Land 
O’Lakes’ failure to perform hereunder will be excused to the extent such performance is rendered 
impossible by strike, pandemic (including SARS-CoV-2), fire, flood, or other act of nature, governmental 
acts, orders or restrictions, or any other reason where failure to perform is beyond the reasonable control 
and not caused by the negligence of Land O’Lakes. This Agreement will not be construed as creating a 
relationship of employment, agency, partnership, joint venture, or any other form of legal association. 
Neither party has any power to bind the other party or to assume or to create any obligation or 
responsibility on behalf of the other party. This Agreement will not confer any rights or remedies upon any 
person other than the parties, Land O’Lakes’ affiliates and their respective successors and permitted 
assigns and the Agreement. indemnified parties (with respect to indemnification). Any notices provided 
hereunder will be in writing and will be deemed to have been duly given when delivered, or three (3) days 
after mailing by U.S. certified mail, return receipt requested, postage prepaid, addressed to the following 
addresses: if to Land O’Lakes: Land O’Lakes, Inc., Attention: Member Relations, P.O. Box 64101, St. Paul, 
Minnesota 55164-0101 with a copy to: Land O’Lakes, Inc., Attention: Law Department – MS 2500, P.O. Box 
64101, St. Paul, MN 55164-0101; and, if to you: to the last address you gave us. This Agreement and the 
Services Agreement(s) constitute the entire agreement between the parties with respect to its subject 
matter and as of the date of agreement by you supersedes all prior or contemporaneous agreements, 
negotiations, representations, and proposals, whether written or oral, relating to its subject matter (subject 
to the exceptions set forth in this Agreement). Except for modifications made by us to this Agreement as 
noted in the recitals, no modification of this Agreement and no waiver of any breach of this Agreement 
will be effective unless in writing and signed by an authorized representative of the party against whom 
enforcement is sought. The Uniform Computer Information Transactions Act will not apply to this 
Agreement, or any business conducted pursuant to it, regardless of when and however adopted, enacted, 
and amended under the Laws of any jurisdiction. Where “including” is used herein it means “including but 
not limited to.”
		</li>
</ol>
<p>Revision 5/01/2025</p>
</div>`
}